import home from './home';

export default {
  homePage: home.ar_SA,
  common: {
    reload: '刷新',
    notData: '暂无数据',
    error_500: '服务器开小差了，请稍后重试',
    imgError: '图片尺寸过大',
    imgFiail: '图片上传失败',
    pageTitleText: '比特币交易平台',
    year: '年',
    mouth: '月',
    zhang: '张',
    time: '日期',
    email: '邮箱',
    phone: '电话号码',
    search: '查询',
    coin: '币种',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    date: ['日', '一', '二', '三', '四', '五', '六'],
  },
  phoneCode: {
    A: [
      '阿富汗 +93+4',
      '阿尔巴尼亚 +355+8',
      '阿尔及利亚 +213+12',
      '美属萨摩亚 +684+16',
      '安道尔 +376+20',
      '安哥拉 +244+24',
      '安圭拉岛 +1264+660',
      '安提瓜和巴布达 +1268+28',
      '阿根廷 +54+32',
      '亚美尼亚 +374+51',
      '澳大利亚 +61+36',
      '奥地利 +43+40',
      '阿塞拜疆 +994+31',
    ],
    B: [
      '巴哈马 +1242+44',
      '巴林 +973+48',
      '孟加拉国 +880+50',
      '巴巴多斯 +1246+52',
      '白俄罗斯 +375+112',
      '比利时 +32+56',
      '伯利兹 +501+84',
      '贝宁 +229+204',
      '百慕大群岛 +1441+60',
      '玻利维亚 +591+68',
      '博茨瓦纳 +267+72',
      '巴西 +55+76',
      '文莱 +673+96',
      '保加利亚 +359+100',
      '布基纳法索 +226+854',
      '布隆迪 +257+108',
    ],
    C: [
      '柬埔寨 +855+116',
      '喀麦隆 +237+120',
      '加拿大 +1+124',
      '开曼群岛 +1345+136',
      '中非共和国 +236+140',
      '乍得 +235+148',
      '智利 +56+152',
      // '中国 +86+156',
      '哥伦比亚 +57+170',
      '刚果 +242+178',
      '库克群岛 +682+184',
      '哥斯达黎加 +506+188',
      '科特迪瓦 +225+384',
      '古巴 +53+192',
      '塞浦路斯 +357+196',
      '捷克共和国 +420+203',
    ],
    D: [
      '丹麦 +45+208',
      '吉布提 +253+262',
      '多米尼加共和国 +1890+214',
    ],
    E: [
      '厄瓜多尔 +593+218',
      '埃及 +20+818',
      '萨尔瓦多 +503+222',
      '爱沙尼亚 +372+233',
      '埃塞俄比亚 +251+231',
    ],
    F: [
      '斐济群岛 +679+242',
      '芬兰 +358+246',
      '法国 +33+250',
      '法属圭亚那 +594+254',
      '法属波利尼西亚 +689+258',
    ],
    G: [
      '加蓬 +241+266',
      '冈比亚 +220+270',
      '乔治亚 +995+268',
      '德国 +49+276',
      '加纳 +233+288',
      '直布罗陀 +350+292',
      '希腊 +30+300',
      '格林纳达 +1809+308',
      '关岛 +1671+316',
      '危地马拉 +502+320',
      '几内亚 +224+324',
      '圭亚那 +592+328',
    ],
    H: [
      '海地 +509+332',
      '洪都拉斯 +504+340',
      '香港 +852+344',
      '匈牙利 +36+348',
    ],
    I: [
      '冰岛 +354+352',
      '印度 +91+356',
      '印度尼西亚 +62+360',
      '伊朗 +98+364',
      '伊拉克 +964+368',
      '爱尔兰 +353+372',
      '以色列 +972+376',
      '意大利 +39+380',
    ],
    J: [
      '牙买加 +1876+388',
      '日本 +81+392',
      '约旦 +962+400',
    ],
    K: [
      '哈萨克斯坦 +7+398',
      '肯尼亚 +254+404',
      '朝鲜 +850+408',
      '韩国 +82+410',
      '科威特 +965+414',
      '吉尔吉斯斯坦 +331+417',
    ],
    L: [
      '老挝 +856+418',
      '拉脱维亚 +371+428',
      '黎巴嫩 +961+422',
      '莱索托 +266+426',
      '利比里亚 +231+430',
      '利比亚 +218+434',
      '列支敦士登 +423+438',
      '立陶宛 +370+440',
      '卢森堡 +352+442',
      '卢旺达 +250+646',
    ],
    M: [
      '澳门 +853+446',
      '马达加斯加 +261+450',
      '马拉维 +265+454',
      '马来西亚 +60+458',
      '马尔代夫 +960+462',
      '马里 +223+466',
      '马耳他 +356+470',
      '马提尼克岛 +596+474',
      '毛里求斯 +230+480',
      '墨西哥 +52+484',
      '摩尔多瓦 +373+498',
      '摩纳哥 +377+492',
      '蒙古 +976+496',
      '蒙特塞拉特 +1664+500',
      '摩洛哥 +212+504',
      '莫桑比克 +258+508',
      '缅甸 +95+104',
    ],
    N: [
      '纳米比亚 +264+516',
      '瑙鲁 +674+520',
      '尼泊尔 +977+524',
      '荷兰 +31+528',
      '荷属安的列斯群岛 +599+530',
      '新西兰 +64+554',
      '尼加拉瓜 +505+558',
      '尼日尔 +227+562',
      '尼日利亚 +234+566',
      '挪威 +47+578',
    ],
    O: [
      '阿曼 +968+512',
    ],
    P: [
      '巴基斯坦 +92+586',
      '巴拿马 +507+591',
      '巴布亚新几内亚 +675+598',
      '巴拉圭 +595+600',
      '秘鲁 +51+604',
      '菲律宾 +63+608',
      '波兰 +48+616',
      '葡萄牙 +351+620',
      '波多黎各 +1787+630',
    ],
    Q: [
      '卡塔尔 +974+634',
    ],
    R: [
      '留尼汪岛 +262+638',
      '罗马尼亚 +40+642',
      '俄罗斯 +7+643',
    ],
    S: [
      '圣卢西亚 +1758+662',
      '圣文森特和格林纳丁斯 +1784+670',
      '萨摩亚 +685+882',
      '圣马力诺 +378+674',
      '圣多美和普林西比 +239+678',
      '沙特阿拉伯 +966+682',
      '塞内加尔 +221+686',
      '塞舌尔 +248+690',
      '塞拉利昂 +232+694',
      '新加坡 +65+702',
      '斯洛伐克 +421+703',
      '斯洛文尼亚 +386+705',
      '所罗门群岛 +677+90',
      '索马里 +252+706',
      '南非 +27+710',
      '西班牙 +34+724',
      '斯里兰卡 +94+144',
      '苏丹 +249+736',
      '苏里南 +597+740',
      '斯威士兰 +268+748',
      '瑞典 +46+752',
      '瑞士 +41+756',
      '叙利亚 +963+760',
    ],
    T: [
      '台湾 +886+158',
      '塔吉克斯坦 +992+762',
      '坦桑尼亚 +255+834',
      '泰国 +66+764',
      '多哥 +228+768',
      '汤加 +676+776',
      '特立尼达和多巴哥 +1809+780',
      '突尼斯 +216+788',
      '土耳其 +90+792',
      '土库曼斯坦 +993+795',
    ],
    U: [
      '乌干达 +256+800',
      '乌克兰 +380+804',
      '阿拉伯联合酋长国 +971+784',
      '英国 +44+826',
      '美国 +1+840',
      '乌拉圭 +598+858',
      '乌兹别克斯坦 +998+860',
    ],
    V: [
      '委内瑞拉 +58+862',
      '越南 +84+704',
    ],
    Y: [
      '也门 +967+887',
    ],
    Z: [
      '赞比亚 +260+894',
      '津巴布韦 +263+716',
    ],
  },
  etfAdd: {
    fundRate: '资金费率',
    title: 'ETF交易',
    dialogTitle: '免责声明',
    confirmText: '我已阅读并同意',
    dText1: '尊敬的客户，您好！',
    dText3: '感谢您登陆并使用本平台提供的杠杆ETF产品和相关服务（以下简称“ETF产品”）。请你仔细阅读ETF产品说明和如下风险提示，您在阅读后继续使用ETF产品，即视为您已经完全了解并理解ETF产品的风险，能够承担使用ETF产品可能带来的损失，并视为您同意本免责声明的全部内容。',
    dText4: '请点击此阅读ETF产品说明：',
    dText5: '《杠杆ETF产品FAQ》',
    dText6: '风险提示',
    dText7: '1.您购买/出售的价格不应该较单位净值有较大的偏差，不然您会蒙受相应的损失。',
    dText8: '2.如果方向判断错误，在极端行情下会存在价格趋近于归零的风险。',
    dText9: '平台在此郑重的提醒您，因上述风险导致的损失或责任，均由您自行承担，平台对此不承担任何责任。本免责声明与平台内的其他协议、声明、规则等一起，构成平台与您就平台的服务和产品所达成的全部合意。',
    sbyText1: '1、“3L”表示标的交易对价格上涨1%，该产品净值上涨3%',
    sbyText2: '2、“3S”表示标的交易对价格下跌1%，该产品净值上涨3%',
    sbyText3: '3、净值正常每天0点进行调整，极端行情会在盘中进行调整',
    sbyText4: '4、每倍杠杆将按天收取相应的管理费用',
    sbyText5: '5、交易前请注意查看净值，该产品在极端行情下会存在价格趋近于归零，价格远远偏离净值的风险，请投资者注意控制风险',
    sbyText6: '更多详情请查看公告',
    jz: '净值',
    jzText1: '看多净值=上个调整时点的净值*[1+3*(现货最新成交价-现货上个调整时点价格)/现货上个调整时点价格*100%；',
    jzText2: '看空净值=上个调整时点的净值*[1-3*(现货最新成交价-现货上个调整时点价格)/现货上个调整时点价格*100%；',
  },
  broker: {
    broker: '经纪人系统',
    invitations: '邀请总人数',
    indirect: '直接邀请人数',
    myType: '我的角色',
    revenue: '累计返佣',
    export: '导出文档',
    promptText1: '请输入UID',
    promptText2: '请输入手机号',
    promptText3: '请输入邮箱',
    time: '时间',
    phoneeNumber: '手机号',
    email: '邮箱',
    remaid: '返佣记录',
    agentAccount: '持仓统计',
    tier: '层级',
    fee: '手续费',
    amount: '返佣额度',
    opera: '操作',
    ccNumber: '持仓量',
    view: '查看',
    symbolType: '币种',
    type: '类型',
    returnDetails: '返佣明细',
    scale: '返佣比例',
    startTime: '起始时间',
    endTime: '结束时间',
  },
  pageTitle: {
    market: '行情',
    login: '登录',
    register: '注册',
    resetPass: '找回密码',
    personal: '个人中心',
    order: '订单中心',
    assets: '资产中心',
    trade: '现货交易',
    home: '首页',
    cms: '帮助中心',
    mesage: '消息中心',
    noticeInfo: '公告中心',
    otcTrade: '广告详情',
    otcRelease: '发布广告',
    otcDetailOrder: '订单详情',
    fiatdeal: '法币交易',
    appDownload: 'APP下载',
    broker: '经纪人系统',
    mining: '交易挖矿',
    innovation: '创新试验区',
    contract: '合约交易',
    manageFinances: '理财宝',
    manageFinancesView: '理财宝详情',
    manageFinancesOrder: '理财记录',
    questions: '问题中心',
    b2cFiatdeal: '法币交易',
  },
  header: {
    broker: '经纪人系统',
    trade: '现货交易',
    otc: '法币交易',
    lever: '杠杆交易',
    co: '合约交易',
    assets: '资产',
    order: '订单',
    zh: '简体中文',
    login: '登录',
    register: '注册',
    more: '查看更多',
    moreText: '更多',
    account: '用户中心',
    message: '消息',
    set: '设置',
    color: '色彩主体',
    userStatus: '账户状态',
    out: '退出',
    userStatus1: '正常',
    userStatus2: '冻结交易，冻结提现',
    userStatus3: '冻结交易 3冻结提现',
    minings: '交易挖矿',
    innov_tit: '创新试验区',
    appDownLoad: 'app 下载',
    market: '行情',
    up_down_color: '涨跌颜色',
    red_up_green_down: '红涨绿跌',
    green_up_red_down: '绿涨红跌',
  },
  krwAdd: {
    bod: '出生年月日',
    regst1: '隐私条款',
    regst2: '用户协议',
    regst3: '营销广告使用同意书',
    regstmust: '（必选）',
    regstother: '（可选）',
    hometitle: '温馨提示',
    hometext1: ' ',
    hometext2: ' ',
    hometext3: ' ',
    hometext4: ' ',
    hometext5: ' ',
    hometext6: ' ',
    hometext7: '下次不再提示',
    hometext8: '确定',
  },
  personal: {
    exccAuth: {
      errorText1: '已拒绝授权，请选择其他方式完成KYC',
      text1: '国家',
      text2: '选择提交方式',
      text3: '方式一',
      text4: '方式二',
      text5: '手动填写表单',
      text6: '按照平台要求人工填写提交信息',
      text7: '登录SingPass提交',
      text8: '通过登录您的SingPass账户，授权获取信息，免填写。（对新加坡公民、永久居留或当地工作的外籍人士使用。）',
    },
    exccAuthorization: {
      title: '请确认您的信息，提交后信息无法修改',
      title2: '实名认证',
      promptText1: '别名',
      promptText2: '性别',
      promptText3: '身份证/居住证/护照号码',
      promptText4: '全名',
      promptText5: '国籍',
      promptText6: '居留身份',
      promptText7: '出生日期',
      promptText8: '出生国家',
      promptText9: '注册地址',
      promptText10: '手机号码',
      promptText11: '通信地址',
      promptText12: '收入来源',
      income1: '工资',
      income2: '投资',
      income3: '储蓄',
      income4: '退休金',
      income5: '继承',
      income6: '家庭经济支持',
      income7: '其他',
      submit: '提交',
    },
    exccAuthForm: {
      promptText1: '姓名',
      promptText2: '性别',
      promptText3: '出生日期',
      promptText4: '住宅地址',
      promptText5: '市',
      promptText6: '邮政编码',
      promptText7: '国家或地区',
      promptText8: '身份证/居住证/护照号码',
      promptText9: '收入来源',
      text1: '重新上传居住证明',
      text2: '居住证明',
      text3: '支持小于8M的JPG、JPEG或PNG格式图片。',
      text4: '证件照片要求清晰，不允许任何修改和遮挡，必须能看清人像、证件号和姓名。',
      text5: '照片需免冠，建议未化妆，手持证件人的五官清晰可鉴，完整露出手臂。',
      text6: '手持证件+签名照：需要一张本人同时手持身份证正面和个人手写文案的照片。文案包括：“姓名+申请日期+本站域名+我在本站的所有行为均为本人操作，并已知悉相关风险，愿意承担相关操作的一切法律后果”。',
      text7: '居住证明：请上传电费账单（例如燃气，水或电）或银行对账单或手机账单或互联网账单的整页扫描。该法案必须有您的全名，并且必须在最近6个月内签发。',
      text8: '重新上传身份证背面/护照封面',
      text9: '身份证背面/护照封面',
      text10: '重新上传身份证正面/护照个人信息页',
      text11: '身份证正面/护照个人信息页',
      text12: '重新上传手持证件+签名照',
      text13: '手持证件+签名照',
      text14: '在此平台认证，您需要年满',
      sex1: '男',
      sex2: '女',
      text15: '请描述收入来源',
      text16: '请输入正确的出生日期，如:yyyy-mm-dd',
      text17: '日期格式如：yyyy-mm-dd',
      text18: '进行交易操作前，请提交实名认证信息并通过审核。',
      text19: '进行充提操作前，请提交实名认证信息并通过审核。',
    },
    kyc: {
      areaTitle: '国家或地区',
      area: '请选择您的国家或地区',
      kycAuth1: '请使用手机浏览器扫描下方二维码，打开实名认证界面。',
      kycAuth2: '拍摄身份证正反面，并通过人脸识别即可完成认证',
      kycAuth3: '二维码有效期',
      kycAuth4: '二维码已过期，请刷新页面重新获取',
      kycAuth5: '已在手机上完成验证',
      kycAuth6: '想继续在当前界面完成认证？',
      kycAuth7: '已存在实名认证信息',
      kycAuth8: '请扫描二维码完成认证',
      kycAuth9: '请通过人工通道完成实名认证',
      kycMin: '分',
      kycSec: '秒',
      type: '证件类型',
      name: '名',
      fName: '姓',
      text1: '请注意：最少需要提供一种有效证件，证件一旦上传不可更改，证件不可重复使用，请认真填写。',
      text2: ' ',

      type1: '护照',
      type2: '身份证',
      type3: '驾照',
      type4: '其他合法证件（如社保卡，居住证，户口本等）',

      valueText1: '证件1号码',
      valueText2: '证件2号码',

      value1: '护照号码',
      value2: '身份证号码',
      value3: '驾驶证号码',
      value4: '其他证件号码',
      Optional: '选填',
      require: '必填',
    },
    krw: {
      authType: '韩国',
      authOther: '外国人',
      auth: '认证',
      niceN: '手机实名认证（韩国人认证入口）',
      niceText: '用于平台确认您的身份信息',
      bank: '银行卡',
      bankText: '绑定后才可提现',
      authLevel: '身份认证',
      authLevelText: '为了您的资产安全，请尽快完成身份认证',
      account: '账号',
      selectArea: '请选择您的国籍',
      niceConfrim: '已认证',
      niceConfrimTitle: '手机实名认证',
      niceConfrimText: '手机实名认证，等待中...',
      alertText: '为了您的账户安全，请完成以下验证方式',
      inow: '我知道了',
      alertk: '手机实名认证或身份认证',
      OTPk: 'OTP认证',
      phonek: '请您先完善手机实名认证',
    },
    krwBank: {
      addBank: '绑定银行账号',
      setBank: '修改银行账号',
      userName: '户名',
      country: '开户行',
      bankAccount: '银行账号',
      bankAccountError: '请输入正确银行账号',
      smsCode: '短信验证码',
      smsCodeError: '请输入6位数字短信验证码',
      googleCode: '谷歌验证码',
      googleCodeError: '请输入6位数字谷歌验证码',
    },
    label: {
      smsCodeText: '短信验证码',
      googleCodeText: '谷歌验证码',
      emailCodeText: '邮箱验证码',
      newEmailCodeText: '新邮箱验证码',
      moneyPassword: '资金密码',
      oldMoneyPassword: '新资金密码',
      confirmMoneyPassword: '确认资金密码',
      newConfirmMoneyPassword: '确认新资金密码',
      ipText: 'IP地址',
      noteText: '备注',
      promptText: '所在地',
      errorText: '请选择国家',
      phone: '手机号',
      oldPhone: '原手机号码',
      newPhone: '新手机号码',
      oldPassword: '原登录密码',
      password: '登录密码',
      newPassword: '新登录密码',
      newPasswordAgain: '确认新登录密码',
      oldEmail: '原邮箱地址',
      newEmail: '新邮箱地址',
      email: '邮箱地址',
      idCard: '身份证',
      idCardNum: '证件号码',
      promptText1: '住址 (请注意住址必须与下一步提供的住址证明一致)',
      passport: '护照',
      name: '姓名',
      inviteCode: '邀请码',
      inviteUrl: '邀请链接',
      inviteQECode: '我的二维码',
      inviteTitle: '我的邀请码',
    },
    tool: {
      modify: '修改',
      bind: '绑定',
      delete: '删除',
      setUp: '设置',
      add: '添加',
      submit: '提交',
      create: '创建',
      view: '查看',
      confirm: '确认',
    },
    prompt: {
      errorTextName: '昵称不能为空',
      errorTextLength: '昵称长度不可超过十位',
      ipErrorText: '请输入正确的ip地址',
      copySucces: '复制成功',
      errorCode: '请输入六位数字验证码',
      errorPhone: '请输入正确的手机号码',
      errorPhoneText: '请输入手机号码',
      errorNewPhone: '请输入新手机号码',
      ipCode: '请输入正确的ip地址',
      noteCode: '请输入备注',
      uploading: '正在上传',
      uploadQrCod: '上传二维码图片',
      uploadQrCodAgain: '重新上传二维码图片',
      uploadType: '支持JPG、PNG格式，文件小于8M',
      warningApi: '请您不要泄露密钥，以免造成资产损失，单个用户最多创建5个密钥;建议为密钥绑定IP，每个密钥最多绑定5个IP，用英文逗号隔开。',
      warningChangePhone: '修改手机后48小时内禁止提币',
      warningChangePassword: '修改登录密码后48小时内禁止提币',
      warningChangeEmail: '修改邮箱后48小时内禁止提币',
      warningPassword: '修改资金密码后48小时内禁止提币',
      errorPasswordText: '请输入8～20位,至少包括数字+字母',
      errorPasswordTwo: '两次新密码输入不一致',
      errorEmailText: '请输入正确的邮箱地址',
      errorEmail: '请输入邮箱地址',
    },
    state: {
      certification: '认证',
      certified: '已认证',
      authentication: '认证中',
      closeValidatio: '关闭验证',
      openValidatio: '开启认证',
      open: '已开启',
      closeSuccess: '关闭成功',
      openSuccess: '开启成功',
      release: '发布中',
      trading: '交易中',
      overdue: '过期',
      close: '关闭',
      closed: '已关闭',
    },
    alert: {
      title: '安全提醒',
      fiatTitle: '法币设置提醒',
      button: '去开启',
      certif: '去认证',
      text: '为了您的账户安全，请您至少开启一项验证方式。',
      fiatText: '您的账户必须通过实名认证并设置昵称且至少开启一项安全验证方式才能添加收款方式和设置资金密码。',
      enforceGoogleAuth: '您的账户必须通过实名认证并设置昵称且开启谷歌验证才能添加收款方式和设置资金密码。',
      alertErrorTextGoogle: '绑定谷歌验证',
      alertErrorTextPhone: '绑定手机验证',
      buttonOpen: '去激活',
      textOpen: '您需要绑定并激活至少一种收款方式，才可出售数字货币',
      payTypeError: [
        '买家仅支持通过',
        '向您付款，您需要添加并激活相应收款方式。',
      ],
      nickName: '昵称',
      id: '实名认证',
    },
    dialog: {
      title: '修改昵称',
      name: '昵称',
      text: '请输入昵称',
      closeAd: '关闭广告',
      closeAdPrompt: '关闭广告将不再进行交易，您确认关闭此广告吗？',
      blackPrompt: '提示',
      blackPromptText: '您确定将对方从黑名单中移除吗？',
    },
    navMenu: {
      title: '用户中心',
      list: {
        inviteCodeManagement: '邀请码管理',
        userManagement: '账号管理',
        safetyRecord: '安全记录',
        leaglTenderSet: '法币设置',
        advertisingManagement: '广告管理',
        blackList: '黑名单',
        apiManagement: 'API管理',
      },
    },
    userManagement: {
      nameError1: '昵称不能为空',
      nameError2: '昵称长度不可超过十位',
      nameError3: '仅允许使用英文字母、数字(0-9)、中文与特殊字符("-”"_")',
      userName: '昵称',
      id: 'ID',
      securityTitle: '安全设置',
      otherTitle: '其它',
      inviteLink: '查看我的邀请',
      securityList: {
        password: {
          text: '登录密码',
          label: '***********',
        },
        idAuth: {
          text: '实名认证',
          label: '为了您的资产安全请尽快完成实名认证',
        },
        email: {
          text: '邮箱',
          label: '用于登录、提币、安全设置时使用',
        },
        phone: {
          text: '手机号',
          label: '用于提现，修改密码，安全设置时用以收取验证短信',
        },
        google: {
          text: '谷歌验证码',
          label: '用于提币、找回密码、修改安全设置、管理API时进行安全验证',
        },
      },
      otherList: {
        poundage: {
          text: '平台币作为手续费',
          label: '用于交易所行情、交易计价货币单位',
        },
        myInviteCod: {
          text: '我的邀请码',
          label: '用于邀请新用户',
        },
        myInvite: {
          text: '我的邀请',
          // label: '用于邀请新用户',
        },
        superPeerCod: {
          text: '超级节点',
          // label: '用于邀请新用户',
        },
        superDeputyCod: {
          text: '超级代表',
          // label: '用于邀请新用户',
        },
      },
    },
    safetyRecord: {
      navTab: [
        '登录历史',
        '安全设置历史',
      ],
      loginColumn: [
        '登录时间',
        '登录方式',
        'IP地址',
        '状态',
      ],
      settingColumn: [
        '设置时间',
        '设置内容',
        'IP地址',
      ],
      success: '成功',
      failure: '失败',
    },
    inviteCodeManagement: {
      title: '邀请好友，交易反佣',
      titleText: '当日即得手续费30%返佣福利',
      showNumber: '邀请人数',
      showCommission: '获得返佣',
      commissionWay: '邀请方式',
      commissionRecor: '邀请记录',
      columns: [
        '时间',
        '被邀请人账号',
      ],
    },
    myInvite: {
      title1: '边交易',
      title2: '边挖矿',
      title3: '告别',
      title4: ' ',
      title5: '高昂手续费',
      my: '我的邀请',
      number: '邀请人数(人)',
      reward: '邀请收入({coin})',
      profits: '挖矿返利({coin})',
      code: '默认邀请码',
      link: '默认邀请链接',
      invite: '立即邀请',
      details: '邀请详情',
      myReward: '邀请收入',
      list: '邀请列表',
      profitsList: '挖矿返利',
      time: '注册时间',
      user: '账户名',
      status: '奖励状态',
      miningDetails: '挖矿明细({coin})',
      miningRewards: '邀请挖矿奖励({coin})',
      statusItem1: '未发放',
      statusItem2: '已发放',
    },
    leaglTenderSet: {
      title: '收款管理',
      titleList: [
        {
          text: '收款方式设置',
          label: '请务必使用您本人的实名账户，被激活的收款方式将在交易时向买方展示，最多激活3种',
        },
        {
          text: '资金密码',
          label: '为确保您的资金安全请设置资金密码',
        },
      ],
    },
    setUp: {
      title1: '设置收款方式',
      title2: '添加收款方式',
      hint: '每种法币可绑定一张银行卡，最多可绑定4个银行卡',
      paymentMethods: {
        text: '收款方式',
        errorText: '请选择收款方式',
        text2: '法币类型',
        errorText2: '请选择法币类型',
        paymentsWA: {
          name: '姓名',
          title: '账号',
          type: '账号类型',
        },
        paymentsCard: {
          name: '姓名',
          bank: '开户行',
          branch: '开户支行(选填)',
          account: '银行账号',
        },
      },
    },
    advertisingManagement: {
      navTab: [
        '购买广告',
        '出售广告',
      ],
      columns: [
        '创建时间',
        'ID',
        '币种',
        '单价',
        '数量',
        '状态',
        '操作',
      ],
    },
    blackList: {
      title: '黑名单',
      columns: [
        '用户',
        '信用值',
        '历史交易',
        '交易次数',
        '操作',
      ],
      closeText: '移除黑名单',
    },
    APImanagement: {
      navTab: [
        '创建API',
        'API行情文档',
        'API交易文档',
      ],
      columns: [
        '备注',
        'IP地址',
        'APIKey',
        'SecretKey',
        '操作',
      ],
      columnsApi: [
        '接口',
        '描述',
      ],
      recordTitle: 'API记录',
      downloadDocumen: '下载文档',
      titleText: '确认密钥',
      secretKey: 'secretKey',
      APIKye: 'APIKye',
      ip: 'IP地址',
      note: '备注',
      apiList: [
        '获取K线数据',
        '获取当前行情',
        '获取行情成交记录',
        '查询买卖盘深度',
        '获取全部委托',
        '获取全部成交记录',
        '取消委托单',
        '查询系统支持的所有交易对及精度',
        '创建订单',
        '获取各个币对的最新成交价',
        '获取当前委托',
        '获取订单详情',
        '资产余额',
      ],
    },
    checkApi: {
      title: '查看SecretKey',
    },
    modifyApi: {
      title: '修改APIKey',
    },
    changePhone: {
      title: '修改手机',
    },
    changePassword: {
      title: '修改登录密码',
    },
    changeEmail: {
      title: '修改邮箱',
    },
    bindEmail: {
      title: '绑定邮箱',
    },
    bindGoogle: {
      title: '绑定谷歌认证',
      downloadGoogle: [
        '下载谷歌验证器APP',
        'iOS用户登录App Store搜索“Authenticator”下载。安卓用户登录应用商店或使用手机浏览器搜索“谷歌验证器”下载。',
      ],
      useGoogle: [
        '使用谷歌身份验证器扫描二维码或手动输入密钥',
        '打开谷歌验证器，扫描下方二维码或手动输入下述密钥添加验证令牌。',
      ],
      bindGoogle: [
        '完成绑定',
        '密钥用于手机更换或遗失时找回谷歌验证器，绑定前请务必将上述密钥备份保存。',
      ],
      appStore: 'App Store',
      googlePlay: 'Google Play',
      android: 'Android',
    },
    bindPhone: {
      title: '绑定手机',
    },
    closeGoogle: {
      title: '关闭谷歌认证',
    },
    closePhone: {
      title: '关闭手机认证',
    },
    idAuth: {
      title: '实名认证',
      info: '基本信息',
      uploadDocuments: '上传图片',
      submitted: '已提交',
      promptTextType: '证件类型',
      next: '下一步',
      uploadIdCardPositive: '证件1:头像面',
      uploadIdCardPositiveAgain: '重新上传证件1:头像面',
      uploadIdCardBack: '证件1:背面(护照不需要背面)',
      uploadIdCardBackAgain: '重新上传证件:背面',

      uploadIdCardPositive2: '证件2:头像面',
      uploadIdCardPositiveAgain2: '重新上传证件2:头像面',
      uploadIdCardBack2: '证件2:背面',
      uploadIdCardBackAgain2: '重新上传证件2:背面',

      uploadIdCardPersonalPositiv: '上传证件与个人签名照',
      uploadIdCardPersonalPositivAgain: '重新上传证件与个人签名照',

      uploadAddress: '身份证、居住证等有地址面或者水电煤气网缴费单其中之一',

      uploadPassportPositive: '上传证件封面',
      uploadPassportPositiveAgain: '重新上传证件封面',
      uploadPassportBack: '上传证件个人信息页',
      uploadPassportBackAgain: '重新上传证件个人信息页',
      uploadPassportPersonalPositiv: '手持证件与个人签名照',
      uploadPassportPersonalPositivAgain: '重新上传手持证件与个人签名照',
      uploadText: [
        '支持小于8M的JPG、JPEG或PNG格式图片。',
        '证件照片要求清晰，不允许任何修改和遮挡，必须能看清人像、证件号和姓名。',
        '照片需免冠，建议未化妆，手持证件人的五官清晰可鉴，完整露出手臂。',
        '地址证明：为身份证住址或有效住址。',
        '手持证件与个人签名照:一张本人同时手持证件正面和个人手写字条的照片。字条内容：“姓名+申请日期”',
      ],
      wait: [
        '您的身份信息已提交',
        '请耐心等待审核...',
      ],
      step1: '1. 请下载手机APP，在APP中完成实名认证操作。',
      step2: '2. 手机中APP打开个人中心，按提示完成认证步骤。',
      appDownLoad: '扫码下载APP',
    },
    modifySettings: {
      setTitle: '设置资金密码',
      modifyTitle: '修改资金密码',
    },
  },
  fiatdeal: {
    title: '法币交易',
    paySetting: '支付设置',
    myOrder: '我的订单',
    myAd: '我的广告',
    openA: [
      '更多',
      '收起',
    ],
    navList: [
      '普通交易',
      '购买',
      '出售',
      '大宗交易',
      '购买',
      '出售',
      '发布广告',
      '申请商户',
    ],
    center: {
      header: {
        text: '最新成交均价',
      },
      country: '国家',
      fiat: '法币币种',
      payment: '支付方式',
      idinfo: '开始交易前，您需要完善必要的身份信息及安全验证信息',
      columns: [
        '商家',
        '数量',
        '限额',
        '单价',
        '支付方式',
        '操作',
      ],
      buy: '购买',
      sell: '出售',
      trading: '交易',
      credit: '信用',
      all: '全部',
    },
  },
  stranger: {
    addBlackList: '加入黑名单',
    removeBlackList: '移出黑名单',
    online: '在线',
    offline: '离线',
    already: '已',
    never: '未',
    phone: '手机',
    identity: '身份',
    certification: '认证',
    headerList: [
      '交易次数',
      '总申诉量',
      '胜诉量',
    ],
    blackListPrompt: [
      '您确定将对方加入黑名单吗？',
      '您确定将对方从黑名单中移除吗？',
    ],
    navTab: [
      '购买广告',
      '出售广告',
    ],
    columns: [
      '币种',
      '数量',
      '限额',
      '单价',
      '支付方式',
      '操作',
    ],
    buy: '购买',
    sell: '出售',
    view: '查看',
  },
  home: {
    more: '更多',
    searchSy: '搜索币种',
    market: '市场',
    close: '最新价',
    applies: '涨跌幅',
    height: '最高价',
    low: '最低价',
    H_volume: '24H成交量',
    H_turnover: '24H成交额',
    action: '操作',
    marketSet: '自选',
    chart: '走势',
    moreMarket: '查看更多交易',
    bitsgtitle1: 'Any currency you want',
    bitsgtitle2: 'Popular currencies',
    bitsgtitle3: 'To trade',
    H_coNumber: '持仓量',
    tab_USDT: 'USDT合约',
    tab_USD: '币本位合约',
  },
  trade: {
    dataType1: '基本版',
    dataType2: '专业版',
    dataType3: '深度图',
    datatext1: '开',
    datatext2: '高',
    datatext3: '低',
    datatext4: '收',
    datatext5: '量',
    noUnlock: '充值未解锁',
    freeUnlock: '赠送未解锁',
    ySellVol: '可卖出数量',
    unlockSellBtn: '一键解锁卖出',
    modelInfo: ' 模式说明',
    sellAll: '查看全部',
    balance: '可用余额',
    currencyNotesModal: {
      coinType: '币种简称',
      fullNameCurrency: '币种全称',
      issueTime: '发行时间',
      totalIssueAmount: '发行总量',
      totalCirculation: '流通总量',
      officialWebsite: '官网',
      blockQuery: '区块查询',
      Introduction: '简介',
      relatedLinks: '相关链接',
    },
    searchSy: '搜索币种',
    market: '市场',
    close: '最新价',
    applies: '涨跌幅',
    height: '最高价',
    low: '最低价',
    vol: '成交量',
    H_volume: '24H成交量',
    H_turnover: '24H成交额',
    marketSet: '自选',
    maincon: '主区',
    halving: '减半区',
    newcon: '创新区',
    seecon: '观察区',
    unseal: '解封区',
    notData: '暂无数据',
    handicap: '盘口',
    latestDeal: '实时成交',
    price: '价格',
    number: '数量',
    total: '累计',
    time: '时间',
    activeOrder: '当前委托',
    historyOrder: '历史委托',
    class: '类别',
    transaction: '交易对',
    average: '成交均价',
    status: '状态',
    opera: '操作',
    deal: '已成交',
    noDeal: '未成交',
    turnover: '成交额',
    serviceCharge: '手续费',
    marketPrice: '市价',
    cancelOrder: '撤单',
    cancelled: '撤单成功',
    view: '详情',
    dealMoney: '交易额',
    limitPriceTrade: '限价交易',
    marketPriceTrade: '市价交易',
    total_money: '资产折合',
    buy: '买入',
    sell: '卖出',
    loginReg: '登录/注册',
    mPriceBuy: '以市场最优价买入',
    mPriceSell: '以市场最优价卖出',
    pleaseLogin: '请先登录账号',
    pleasePrice: '请输入价格',
    pleaseInput: '请输入',
    inputError: '输入有误',
    dealCussess: '下单成功',
    full: '全屏',
    outFull: '退出全屏',
  },
  message: {
    mesage: '消息中心',
    noticeInfo: '公告中心',
    help_center: '帮助中心',
    selectAll: '全选',
    delete: '删除',
    readAll: '全部标记为已读',
    pleSelContent: '请选择要删除的内容',
    search: '搜索',
  },
  application: {
    policy: {
      title: '认证商家协议',
      desc: '全球专业站OTC平台<br/>为了保障交易双方的安全、增强本平台注册用户身份的可信度，本平台向您提供商家认证服务。您必须提供必要的真实个人信息以完成认证，本平台有权采取各种合法措施对您所提供的信息进行核验，但是由于网络环境的虚拟性及核验方法限制，本平台对完成认证的商家身份的准确性和真实性不做任何保证。<br/>本协议所有内容中相关条款与您的权利和义务密切相关，请您在开始申请认证商家前，仔细阅读本协议的所有内容，一旦您开始认证流程，即表示您知悉并已充分理解，且同意接受本协议的全部内容。<br/>一、 认证服务的定义与变更<br/>1.认证服务是在商家提供真实可信的身份信息，交纳一定保证金后，在本平台享有一定特权并承担一定义务的服务。除非发生法定情形或者本协议另有约定，一旦您在本平台完成了认证，相应的身份信息和认证结果将不因任何原因被修改或取消；如果您的身份信息在完成认证后发生了变更，您应向本平台提供相应有权部门出具的凭证，由本平台协助您变更您的认证信息。 <br/>2.出于提供更优质服务及保障交易安全的需要，本平台有权根据主客观情况的变化，对本协议内容进行修改或调整，并通过本平台公告变更后的协议文本，无需单独通知您。本协议进行任何修改或变更后，您还继续使用本平台提供的服务，即代表您已阅读、了解并同意接受变更后的协议内容；您如果不同意变更后的协议内容，应立即向本台申请停用认证服务。 <br/>二、 认证商家权利<br/>1.本平台将向申请认证成功的商家提供特有的认证商家标识，该标识在本平台可与未认证的商家进行区分； <br/>2.在本平台发布符合规定的交易广告信息。 <br/>三、认证所需资料及保证金<br/>1.商家个人信息：请将附件商家申请资料内容填写完整并上传。 <br/>2.资产保证金：申请成为认证商家需要向本平台缴纳一定的保证金。保证金将被划至认证商家所属的保证金账户。认证商家在一定期间内无法对该账户内资金无法进行交易或划转。 <br/>四、认证资料的使用<br/>认证资料的报告：您在认证时提交给本平台的认证资料，即不可撤销地授权由本平台保留。除法定或本协议约定的情形外，本平台承诺，不编辑或对任何第三方公开您的认证资料，且不将其用于商业目的，但以下情形除外： <br/>1.您授权本平台透露的相关信息;<br/>2.本平台向国家司法及行政机关提供;<br/>3.本平台向本平台关联企业提供;<br/>4.第三方和本平台一起为用户提供服务时，该第三方向您提供服务所需的相关信息（不包括您的银行账户信息）;<br/>5.基于解决您与第三方民事纠纷的需要，本平台有权向该第三方提供您的身份信息。<br/>五、关于保证金的使用<br/>保证金系用于保障在本平台进行的相关交易的安全。如您在交易过程中发生纠纷，且被判定应对纠纷承担责任并履行相应行为，而您不予配合，本平台有权力对保证金进行处置，处置措施包括但不限于扣留、冻结，或向您的交易对手直接支付。 <br/>六、第三方网站的链接<br/>为实现身份信息审查，本平台上可能包含指向第三方网站（如网上银行网站）的链接（以下简称“链接网站”）。 “链接网站”非由本平台控制，对于任何“链接网站”的内容，包含但不限于“链接网站”内含的任何链接，或“链接网站”的任何改变或更新，本平台均不予负责。自“链接网站”接收的网络传播或其它形式之传送，本平台不予负责。 <br/>七、不得为非法或禁止的使用<br/>接受本协议全部的说明、条款、条件是您申请认证的前提条件。您声明并保证，您不得为任何非法或为本协议、条件及须知所禁止之目的进行认证申请。您不得以任何可能损害、使瘫痪、使过度负荷或损害其他网站或其他网站的服务或本平台或干扰他人对于认证商家申请的使用等方式使用认证服务。您不得经由非本平台许可提供的任何方式取得或试图取得任何资料或信息 <br/>八、免责条款<br/>下列情况导致的个人资料、信息泄露，本平台无需承担任何责任： <br/>1.由于您将账户密码告知他人或未保管好自己的密码或与他人共享账户或任何其他非本平台的过错，导致您的个人资料泄露。<br/>2.任何由于黑客攻击、计算机病毒侵入或发作、电信部门技术调整导致之影响、因政府政策或法律管制而造成的关闭、由于第三方原因(包括不可抗力，例如国际出口的主干线路及国际出口电信提供商一方出现故障、火灾、水灾、雷击、地震、洪水、台风、龙卷风、火山爆发、瘟疫和传染病流行、罢工、战争或暴力行为或类似事件等)及其他非因本平台过错而造成的认证信息泄露、丢失、被盗用或被篡改等。 <br/>3.由于与本平台链接的其它网站（如网上银行等）所造成的银行账户信息泄露及由此而导致的任何法律争议和后果。<br/>4.任何因用户向本平台提供错误、不完整、不实信息等造成不能通过认证或遭受任何其他损失，概与本平台无关。<br/>九、特别声明<br/>1.本平台对认证商家进行的基本资料审查和保证金要求，并不代表认证商家100%可信，也不代表本平台与认证商家之间存在任何保证关系。请本平台用户严格按照流程交易，做好对交易方的资料审核，详尽沟通，保证自身的交易和资产安全！同时，基于数字资产交易的特殊性，您需要在反洗钱方面的风险格外注意，按照KYC原则的要求对您交易对方的身份进行了解，否则您将可能因交易对方涉嫌犯罪而面临资产冻结等风险。 <br/>2.认证商家承诺其向本平台提供的信息是真实合法的，如有虚假或违法，本平台可取消其认证，并扣留其保证金。<br/>十、认证解除<br/>如认证商家需要解除认证，须向本平台提交申请。如认证商家在认证期间无不良记录、影响交易安全或其他违法违规的行为,本平台将于收到申请后两个工作日内审核通过，并将保证金账户内资金划转至需解除认证商家的可操作账户中。',
    },
    applyCompany: '商家申请',
    applyCompanyDesc: '成为商家，享受更多交易特权。',
    serviceList: [
      {
        title: '安全保障',
        desc: '每位商家信息严格保密，绝不外泄',
      },
      {
        title: '发布广告',
        desc: '商家可自由发布广告，买卖更灵活、 更便捷',
      },
      {
        title: '专属标识',
        desc: '商家名称后会显示专属的加v标识增强交易方信任',
      },
      {
        title: '一对一服务',
        desc: '我们将向商家提供一对一专属服务',
      },
    ],
    congratulate: '恭喜您，已通过审核，成为商家',
    congratulateSuper: '恭喜您，已通过审核，成为超级商家',
    applyBtn: '立即申请',
    applyBtnSuper: '申请超级商家',
    relieve: '解除认证',
    confirm: '确定',
    cancel: '取消',
    agree: '我已阅读并同意',
    agreePolicy: '《认证商家协议》',
    relieveing: '解除中',
    dialogDesc: '解除认证后，您将不能发布广告，确定解除？',
    stepProgress: [
      {
        text: '待申请',
        status: 0,
      },
      {
        text: '审核中',
        status: 1,
      },
      {
        text: '完成',
        status: 3,
      },
    ],
    applyRegion: {
      options: [
        '同意冻结',
        '作为商家保证金',
      ],
      applyBtn: '申请',
      applingBtn: '审核中',
      appliedBtn: '返回法币交易大厅',
      cancelBtn: '取消申请',
      focus: '注意事项',
      focusContent: '大宗交易区发布广告必须成为超级商家，商家满足交易效率高、信誉好并同意缴纳大额保证金即可申请成为超级商家。',
      focusContentSuper: '成为超级商家，商家满足交易效率高、信誉好并同意缴纳大额保证金即可申请成为超级商家。',
    },
    company: {
      head: {
        title: '待审核，如何成为商家 ？',
        desc: '请您按照以下步骤完成申请条件',
        titleAppling: '审核中，请耐心等待',
        titleApplied: '恭喜您，成为商家',
        descApplied: '您可享受如下交易特权',
      },
      unApply: {
        stepOne: {
          title: '步骤一  按要求准备下述材料',
          desc: [
            '1.请下载',
            '申请资料模板',
            '，按要求填写申请资料。',
            '2.请录制视频，视频资料要求如下：手持身份证正面，进行视频录制，保持录制过程中声音和影像都清晰<br/>视频诵读范本：本人（姓名），身份证号（身份证号码），我的资金来源合法可靠，自愿交易比特币等数字资产，本人充分了解数字货币及潜在风险，本人具有抗风险的能力并愿意承担一切风险！',
          ],
        },
        stepTwo: {
          title: '步骤二  发送申请邮件',
          desc: [
            '请将以上申请资料和视频资料发送邮件至',
            '，邮件主题为“申请成为商家”',
          ],
        },
        stepThree: {
          title: '步骤三  提交申请',
          desc: [
            '发送邮件后，请在本页面点击“确认申请”按钮，提交申请。并同意冻结',
            '作为商家保证金。提交完成后，您即可在普通交易区发布广告。',
          ],
        },
        stepFour: {
          title: '步骤四  资料审核',
          desc: [
            '我们将在3个工作日内对您的商家申请资料进行审核，请保持通讯畅通，我们会主动与您取得联系。',
          ],
        },
      },
      applying: {
        desc: '1.申请提交成功，您的资料正在审核中。<br/><br/>2.您的保证金已冻结。<br/><br/>3.您已提交申请，如提交资料无误，工作人员将于3个工作日内通过审核。',
      },
      applied: {
        desc: ' 1. 商家可自由发布广告买卖更灵活、更便捷。<br/><br/>2. 商家名称后会显示专属的加“v”标识增强交易方信任。<br/><br/> 3. 我们将向商家提供一对一专属服务。',
      },
    },
    companySuper: {
      head: {
        title: '如何成为超级商家 ？',
        desc: '请您按照以下步骤完成申请条件',
        titleAppling: '审核中，请耐心等待',
        titleApplied: '恭喜您，成为超级商家',
        descApplied: '您可享受如下交易特权',
      },
      unApply: {
        stepOne: {
          title: '步骤一  提交申请',
          desc: [
            '请在本页面点击“申请成为商家”按钮，并同意增加冻结',
            '用作申请升级为超级商家保证金。提交完成后，您即可发布大宗交易广告。',
          ],
        },
        stepTwo: {
          title: '步骤二 审核',
          desc: [
            '我们将在3个工作日内对您的申请进行审核，请保持通讯畅通，我们会主动与您取得联系。',
          ],
        },
      },
      applying: {
        desc: [
          '1. 申请提交成功，您的资料正在审核中。',
          '2. 您已经冻结',
          '保证金。',
          ' 3. 你已提交申请，如提交资料无误，工作人员将于3个工作日内通过审核。',
        ],
      },
      applied: {
        desc: ' 1. 超级商家可在任意区域自由发布广告，买卖更灵活、更便捷。<br/><br/>2. 商家名称后会显示专属的加“v”标识增强交易方信任。<br/><br/>3. 我们将向商家提供一对一专属服务。',
      },
    },
    unEnough: '法币账户可用余额不足',
  },
  login: {
    WelcomeToLogin: '欢迎登录',
    NotRegisteredUsersYet: '还不是注册用户',
    goRegister: '立即注册',
    phoneOrEmail: '账号',
    formatIncorrect: '输入格式不正确',
    password: '密码',
    passwordError: '请输入8～20位,至少包括数字+字母',
    VerificationMode: '验证方式',
    AuthenticationMethod: '请选择验证方式',
    ForgetPassword: '忘记密码',
    login: '登录',
    SecurityVerification: '安全验证',
    MailboxValidation: '邮箱验证',
    MobilePhoneVerification: '手机验证',
    GoogleAuthenticator: '谷歌验证',
    googleCodeError: '请输入6位数字谷歌验证码',
    phoneCodeError: '请输入6位数字手机验证码',
    emailCodeError: '请输入6位数字邮箱验证码',
    codeError: '请输入6位数字验证码',
    googleCode: '谷歌验证码',
    phoneCode: '手机验证码',
    emailCode: '邮箱验证码',
    code: '验证码',
    loginSuccess: '登录成功',
    phoneSendSuccess: '短信已发送，请注意查收',
    emailSendSuccess: '邮件已发送，请注意查收',
    loginPrompt: '(手机号登录无需添加国家区号)',
  },
  register: {
    phoneRegister: '手机号注册',
    emailRegister: '邮箱注册',
    WelcomeToRegister: '欢迎注册',
    AlreadyAregisteredUser: '已经是注册用户',
    logInImmediately: '立即登录',
    location: '所在地',
    PleaseSelectAcountry: '请选择国家',
    password: '密码',
    passwordError: '8-20个字符，必须包含字母和数字，符号包括_.~!@#$%^&*()',
    confirmPassword: '确认密码',
    confirmPasswordError: '两次新密码输入不一致',
    InvitationCodeError: '请输入邀请码',
    IHaveReadAndAgreed: '我已阅读并同意',
    UserAgreement: '用户协议',
    UserAgreementLink: 'https://exchange.zendesk.com/hc/zh-sg/articles',
    register: '注册',
    phone: '手机号',
    phoneError: '手机号输入格式不正确',
    phoneCode: '短信验证码',
    phoneCodeError: '请输入6位数字短信验证码',
    email: '邮箱',
    emailError: '邮箱输入格式不正确',
    emailCode: '邮箱验证码',
    emailCodeError: '请输入6位数字邮箱验证码',
    InvitationCodeOptional: '邀请码(选填)',
    InvitationCodeIsRequired: '邀请码',
    registerSuccessQLogin: '注册成功，已登录',
    scrollCode: '请滑动安全验证后再获取验证码',
    phoneSendSuccess: '短信已发送，请注意查收',
    emailSendSuccess: '邮件已发送，请注意查收',
    registerSuccess: '注册成功，请您登录',
    passwordStrength: '密码强度',
    weak: '弱',
    medium: '中',
    strong: '强',
    strengthCondition_1: '8 - 20位字符含数字',
    strengthCondition_2: '大小写字母',
    strengthCondition_3: '特殊符号',
  },
  resetPass: {
    googleCode: '谷歌验证码',
    googleError: '请输入六位数字谷歌验证码',
    IDCode: '证件号码',
    IDError: '请输入证件号码',
    next: '下一步',
    submit: '提交',
    phoneReset: '手机号找回',
    emailReset: '邮箱找回',
    ResetLoginPassword: '重置登录密码',
    ResetLoginPasswordError: '重置登录密码后48小时内禁止提币',
    password: '新登录密码',
    passwordError: '请输入8～20位,至少包括数字+字母',
    confrimPassWord: '确认登录密码',
    confrimPassWordError: '两次新密码输入不一致',
    phone: '手机号',
    phoneError: '手机号输入格式不正确',
    phoneCode: '短信验证码',
    phoneCodeError: '请输入6位数字短信验证码',
    email: '邮箱',
    emailError: '邮箱输入格式不正确',
    emailCode: '邮箱验证码',
    emailCodeError: '请输入6位数字邮箱验证码',
    resetSuccess: '重置密码成功，请您登录',
    phoneSendSuccess: '短信已发送，请注意查收',
    emailSendSuccess: '邮件已发送，请注意查收',
  },
  assets: {
    branchName: '链名称',
    hideMinAssets: '隐藏小额资产',
    suspend: '暂停',
    withdrawStop: '提现暂停',
    depositStop: '充值暂停',
    b2c: {
      otcShow: {
        header: '法币交易',
        fiatTitle: '法币设置提醒',
        leaglTenderSet: '法币设置',
        fiatdealTitle: '法币交易',
        goHall: '返回法币交易大厅',
        unEnough: '法币账户可用余额不足',
        otcAccount: '法币账户',
        lagel: '法币币种',
        otcOrder: '法币订单',
        otcTradeWarning: '为了保障资金安全，买入的资产将锁定至24h后支持提币和法币卖出等出金操作，在此期间不影响交易等业务',
      },
      lagel: '法币币种',
      allName: '全称',
      recrgeTitle: '充值帐户',
      rechargeSum: '充值金额',
      rechargeMin: '注: 单笔充值不得小于',
      voucherTit: '转账凭证',
      voucherWarn: '通过线下完成转账后，上传您的转账记录',
      voucherCli: '上传转账凭证',
      bankName: '银行名称',
      bankSub: '分行',
      cardNo: '卡号',
      name: '收款人',
      remark: '转账备注',
      withdrawMin: '单笔最小提现金额',
      withdrawMax: '单笔最大提现限额',
      withdrawDay: '今日可提现金额',
      withdrawAddress: '提币账户',
      fee: '手续费',
      arrivalAccount: '到账金额',
      withdrawMinWarn: '单笔提现金额不得小于',
      withdrawMaxWarn: '单笔提现金额不得大于',
      withdrawDayWarn: '今日可提现金额',
      withdrawHaveWarn: '可用余额为',
      addressMent: '提现账户管理',
      addressAddTit: '添加提现账户',
      addressSetTit: '修改提币账户',
      addressListTit: '账户列表',
      warning: '提示',
      deleteWarn: '确定删除',
      payType: '支付方式',
      address: '账户',
      addressUserName: '收款人',
      bankCard: '银行卡',
      set: '编辑',
      firstWay: '收款方式',
      country: '开户行',
      countrySub: '开户支行',
      countryNo: '银行账号',
      submit: '提交',
      b2cRecrgeHisList1: '申请数量',
      b2cRecrgeHisList2: '实际到账',
      b2cRecrgeHisList3: '处理时间',
      seePz: '查看凭证',
      b2cWithdrawHisList1: '到账金额',
    },
    krw: {
      rechargeMin: '充值金额不小于',
      rechargeAccount: '充值银行账号',
      rechargeUserName: '银行账户名',
      rechargeBankName: '银行名称',
      rechargeBankAccount: '银行账号',
      rechargeSum: '充值金额',
      rechargeConfrim: '充值确认',
      rechargeTo: '充值到指定帐号',
      rechargeText: '转账备注内容',
      copySuccess: '复制成功',
      rechargeList1: '申请时间',
      rechargeList2: '到账时间',
      rechargeList3: '币种',
      rechargeList4: '充值金额',
      rechargeList5: '到账金额',
      rechargeList6: '平台账户',
      rechargeList7: '状态',
      rechargeListError: '未到账',
      withdrawAccount: '提现银行账号',
      withdrawUserName: '银行账户名',
      withdrawBankName: '银行名称',
      withdrawBankAccount: '银行账号',
      withdrawFee: '提现手续费',
      withdrawNum: '到账金额',
      withdrawAuth1: '手机实名认证或身份认证',
      withdrawAuth2: 'OTP认证',
      withdrawAuth3: '绑定银行卡',
      withdrawList1: '申请时间',
      withdrawList2: '到账时间',
      withdrawList3: '币种',
      withdrawList4: '提现金额',
      withdrawList5: '手续费',
      withdrawList6: '用户银行账号',
      withdrawList7: '状态',
      withdrawListError: '未到账',
    },
    index: {
      title: '资产中心',
      overview: '总览',
      exchangeAccount: '现货账户',
      coExchangeAccount: '主账户',
      addressMent: '地址管理',
      flowingWater: '资金流水',
      otcAccount: '法币账户',
      otcFlowingWater: '资金流水',
      coAccount: '合约账户',
      leverage: '杠杆账户',
      bibaoAccount: '币宝账户',
      detail: '查看详情',
    },
    leverageAccount: {
      find: '搜索杠杆账户',
      list1: '杠杆账户',
      list2: '总资产',
      list3: '可用',
      list4: '冻结',
      list5: '已借',
      list6: '爆仓价',
      list7: '风险率',
      list8: '操作',
      transfer: '划转',
      ToLoan: '借贷',
    },
    leverageToLoan: {
      typeText1: '本金',
      typeText2: '利息',
      typeText3: '本金+利息',
      title: '借贷',
      can: '可用',
      transfer: '转入',
      warning: '当风险率≤110%时，账户将触发爆仓以归还借贷资金',
      max: '最大额度',
      borrowed: '已借',
      rate: '利率',
      rateMark: '利率是申请借贷时系统收取利息的比例，利息是按照24小时计息',
      number: '借贷数量',
      ToLoan: '借贷',
      listTitle: '最近借贷记录',
      list1: '申请时间',
      list2: '杠杆账户',
      list3: '币种',
      list4: '数量',
      list5: '利率',
      list6: '未还利息',
      list7: '未还数量',
      list8: '操作',
      canToLoan: '可借',
      inputError1: '借贷数量不得大于可借贷数量',
      inputError2: '借贷数量不得小于',
      repayment: '归还',
    },
    leverageTransfer: {
      title: '资金划转',
      leverageAccount: '杠杆账户',
    },
    leverageRepayment: {
      title: '归还',
      symbol: '杠杆账户',
      coin: '归还币种',
      Surplus: '应还数量',
      sum: '借贷数量',
      rate: '利息',
      RepaymentNum: '归还数量',
      error1: '归还数量不得小于',
      error2: '归还数量不得大于可用数量',
      error3: '归还数量不得大于应还数量',
      can: '可用',
    },
    lerverageFlowingWater: {
      direction: '方向',
      symbol: '杠杆账户',
      allCoin: '全部杠杆账户',
      directionAll: '全部',
      directionIn: '转入',
      directionOut: '转出',
      tab1: '当前借贷',
      tab2: '历史借贷',
      tab3: '划转记录',
      tab1List1: '申请时间',
      tab1List2: '杠杆账户',
      tab1List3: '币种',
      tab1List4: '数量',
      tab1List5: '利率',
      tab1List6: '未还利息',
      tab1List7: '未还数量',
      tab1List8: '操作',
      tab2List1: '申请时间',
      tab2List2: '杠杆账户',
      tab2List3: '币种',
      tab2List4: '数量',
      tab2List5: '利率',
      tab2List6: '利息',
      tab2List7: '状态',
      tab3List1: '时间',
      tab3List2: '杠杆账户',
      tab3List3: '币种',
      tab3List4: '数量',
      tab3List5: '方向',
      repayment: '归还',
      status1: '借贷',
      status2: '部分归还',
      status3: '已归还',
      status4: '爆仓',
      status5: '穿仓',
      status6: '爆仓完结',
      status7: '穿仓完结',
    },
    exchangeAccount: {
      positionBalance: '挖矿锁仓',
      incomeLock: '理财锁仓',
      positionV2Amount: '代币锁仓',
      TotalAssets: '总资产折合',
      MyAssets: '我的资产',
      ListOfFunds: '资金列表',
      HideZeroAssets: '隐藏0资产账户',
      SearchCurrency: '搜索币种',
      coin: '币种',
      lumpSum: '总额',
      Available: '可用',
      freeze: '冻结',
      AssetFolding: '资产折合',
      options: '操作',
      other: '其他',
      Recharge: '充值',
      withdraw: '提现',
      position: '锁仓',
      limit: '限制',
      trade: '交易',
    },
    addressMent: {
      pageText: '充币时同时需要一个充币地址和标签(Memo)。标签是保证您充币地址唯一的数字串，与充币地址成对出现并一一对应。请您务必遵守正确的充值步骤，提币时输入完整信息，否则可能造成币的丢失。',
      addAddress: '添加提币地址',
      coin: '币种',
      WithdrawalAddress: '提现地址',
      Remarks: '地址备注',
      label: '标签(Memo)',
      add: '添加',
      listCoin: '币种',
      listRemarks: '备注',
      listAddress: '地址',
      listOptions: '操作',
      AddressList: '地址列表',
      safetyWarning: '安全提示',
      safetyWarningError: '为了您的账户安全，请您至少开启一项验证方式。',
      GotoOpen: '去开启',
      safetyVerification: '安全验证',
      phoneCode: '手机验证码',
      phoneCodeError: '请输入6位数字手机验证码',
      googleCode: '谷歌验证码',
      googleCodeError: '请输入6位数字谷歌验证码',
      bindGoogle: '绑定谷歌验证',
      bindPhone: '绑定手机验证',
      phoneSendSuccess: '短信已发送，请注意查收',
      delete: '删除',
      notSupport: '该币暂不支持交易',
    },
    flowingWater: {
      coin: '币种',
      type: '类型',
      allCoin: '全部币种',
      RechargeRecord: '充值记录',
      WithdrawalsRecord: '提现记录',
      OtherRecords: '其他记录',
      RechargeTime: '充值时间',
      RechargeCoin: '币种',
      RechargeVolume: '充值数量',
      RechargeNumber: '确认次数',
      RechargeStatus: '状态',
      withdrawTime: '提币时间',
      withdrawAddress: '提币地址',
      withUser: '来源用户',
      rechargeAddress: '充值地址',
      withdrawVolume: '提币数量',
      withdrawFee: '手续费',
      withdrawRemarks: '备注',
      withdrawStatus: '状态',
      withdrawOptions: '操作',
      otherTime: '时间',
      otherCoin: '币种',
      otherType: '类型',
      otherVolume: '数量',
      otherStatus: '状态',
      Cancel: '撤销',
      label: '标签',
      updataAt: '钱包处理时间',
      txid: '区块链交易ID',
      type1: '外部充值',
      type2: '内部转入',
    },
    recharge: {
      pageText: '充币时同时需要一个充币地址和标签(Memo)。标签是保证您充币地址唯一的数字串，与充币地址成对出现并一一对应。请您务必遵守正确的充值步骤，提币时输入完整信息，否则可能造成币的丢失。',
      rechargeWarning: '充值时必须要填写充值地址和标签，这是您账户的唯一标识，不填或填错将导致您的资产丢失。',
      recharge: '充值',
      rechargeError: '请勿向上述地址充值任何非本币种资产，否则资产将不可找回',
      minimumDepositAmount: '最小充值金额',
      depositcredited: '充值到账',
      networkConfirmation: '次网络确认',
      rechargeAddress: '充值地址',
      label: '标签(Memo)',
      RecentRechargeRecord: '最近充值记录',
      RechargeReminder: '充值提醒',
      lumpSum: '总额',
      Available: '可用',
      freeze: '冻结',
      RechargeTime: '充值时间',
      RechargeCoin: '币种',
      RechargeVolume: '充值数量',
      RechargeNumber: '确认次数',
      RechargeStatus: '状态',
      copyAddress: '地址复制成功',
      copyLabel: '标签(Memo)复制成功',
      notSupport: '该币暂不支持充值',
    },
    withdraw: {
      pageText: '充币时同时需要一个充币地址和标签(Memo)。标签是保证您充币地址唯一的数字串，与充币地址成对出现并一一对应。请您务必遵守正确的充值步骤，提币时输入完整信息，否则可能造成币的丢失。',
      withdraw: '提现',
      lumpSum: '总额',
      Available: '可用',
      freeze: '冻结',
      MinimumCoinLimit: '最小提币限额',
      MaximumCoinLimit: '最大提币限额',
      dayMaximumCoinLimit: '今日提现剩余',
      CoinAddress: '提币地址',
      label: '标签(Memo)',
      NumberOfCoins: '提币数量',
      fee: '手续费',
      feeError: '请输入正确的手续费',
      allWithdraw: '全部提现',
      buttonWithdraw: '提现',
      addAddrss: '添加提币地址',
      RecentWithdrawalRecords: '最近提现记录',
      safetyWarning: '安全提示',
      safetyWarningError: '为了您的账户安全，请您至少开启一项验证方式。',
      enforceGoogleAuth: '为了您的账户安全，请开启安全验证',
      GotoOpen: '去开启',
      safetyVerification: '安全验证',
      phoneCode: '手机验证码',
      phoneCodeError: '请输入6位数字手机验证码',
      googleCode: '谷歌验证码',
      googleCodeError: '请输入6位数字谷歌验证码',
      bindGoogle: '绑定谷歌验证',
      bindPhone: '绑定手机验证',
      withdrawTime: '提币时间',
      withdrawAddress: '提币地址',
      withdrawVolume: '提币数量',
      withdrawFee: '手续费',
      withdrawRemarks: '备注',
      withdrawStatus: '状态',
      withdrawOptions: '操作',
      NumberOfCoinsError: '请输入提币数量',
      NumberOfCoinsError2: '提币数量需大于手续费',
      NumberOfCoinsError3: '提币数量不得大于可用余额',
      NumberOfCoinsError4: '（提币数量-手续费）需要大于最小提币额且小于最大提币额',
      NumberOfCoinsError5: '（提币数量-手续费）需要小于今日提现剩余',
      phoneSendSuccess: '短信已发送，请注意查收',
      range: '范围',
      account: '对方账户(手机号／邮箱／UID)',
      innerList: '直转记录',
      transferTime: '转账时间',
      transferNumber: '转账数量',
      sideAccount: '对方账户',
      innerTranfer: '站内直转',
      transfer: '转账',
      notSupport: '该币暂不支持提现',
    },
    otcAccount: {
      TotalAssets: '总资产折合',
      ListOfFunds: '资金列表',
      HideZeroAssets: '隐藏0资产账户',
      SearchCurrency: '搜索币种',
      CapitalTransfer: '资金划转',
      coin: '币种',
      Available: '可用',
      freeze: '冻结',
      options: '操作',
      from: '从',
      to: '划转到',
      exchangeAccount: '现货账户',
      otcAccount: '法币账户',
      all: '全部',
      volume: '划转数量',
      volumeError: '可用数量不足',
      can: '可转',
      other: '其他',
      optionCapitalTransfer: '资金划转',
    },
    otcFlowingWater: {
      title: '资金流水',
      type: '类型',
      coin: '币种',
      all: '全部',
      allCoin: '全部币种',
      inOtc: '转入法币',
      outOtc: '转出法币',
      listTime: '时间',
      listCoin: '币种',
      listType: '类型',
      listVolume: '数量',
    },
    coAccount: {
      quota: '账户余额',
      transfer: '资金划转',
      totel: '可用余额',
      accountRight: '账户权益',
      orderMargin: '委托保证金',
      positionMargin: '仓位保证金',
      unrealisedAmount: '未实现盈亏',
      listTitle: '未平仓合约',
      useMarginRate: '保证金已被使用',
      coAccount: '合约账户',
      list1: '合约',
      list2: '仓位数量(张)',
      list3: '已实现盈亏',
      list4: '未实现盈亏',
      list5: '操作',
      type1: '永续',
      type2: '当周',
      type3: '次周',
      type4: '月度',
      type5: '季度',
    },
    coFlowingWater: {
      list1: '时间',
      list2: '类型',
      list3: '金额',
      list4: '合约',
      list5: '合约账户',
    },
    bibaoAccount: {
      bibaoAccount: '币宝账户',
      coin: '币种',
      lumpSum: '总额',
      quota: '余额',
      bibao: '币宝',
      opera: '操作',
      transfer: '转入',
      detail: '详情',
      bibaoDetail: '币宝详情',
      transferNum: '转入数量',
      freed: '释放',
      startTime: '开始时间',
      endTime: '到期时间',
      status: '状态',
    },
  },
  order: {
    index: {
      title: '订单中心',
      exOrder: '现货订单',
      otcOrder: '法币订单',
      leverage: '杠杆订单',
    },
    exchangeOrder: {
      all180: '全部 (近180天)',
      haveCancel: '显示已撤单',
      type: '类别',
      symbol: '交易对',
      market: '市场',
      coin: '币对',
      nowOrder: '当前委托',
      hisOrder: '历史委托',
      all: '全部',
      buy: '买入',
      sell: '卖出',
      nowOrderTime: '时间',
      nowOrderType: '类别',
      nowOrderPrice: '价格',
      nowOrderVolume: '数量',
      nowOrderTotol: '交易额',
      nowOrderAverage: '平均成交价',
      nowOrderTransaction: '已成交/未成交',
      nowOrderOptions: '操作',
      hisOrderTime: '时间',
      hisOrderType: '类别',
      hisOrderPrice: '价格',
      hisOrderVolume: '数量',
      hisOrderAverage: '成交均价',
      hisOrderStatus: '状态',
      hisOrderOptions: '操作',
      marketPrice: '市价',
      cancel: '撤单',
      details: '详情',
      detailsTime: '时间',
      detailsPrice: '价格',
      detailsVolume: '数量',
      detailsTotol: '成交额',
      detailsFee: '手续费',
    },
    otcOrder: {
      haveCancel: '显示已撤单',
      coin: '币种',
      allCoin: '全部',
      nowOrder: '当前委托',
      hisOrder: '历史委托',
      all: '全部',
      buy: '买入',
      sell: '卖出',
      nowOrderId: '订单号',
      nowOrderType: '类别',
      nowOrderCoin: '币种',
      nowOrderPirce: '价格',
      nowOrderVolume: '数量',
      nowOrderTotol: '交易额',
      service: '手续费',
      nowOrderStatus: '状态',
      nowOrderUser: '交易方',
      hisOrderId: '订单号',
      hisOrderType: '类别',
      hisOrderCoin: '币种',
      hisOrderPirce: '价格',
      hisOrderVolume: '数量',
      hisOrderTotol: '交易额',
      hisOrderStatus: '状态',
      hisOrderUser: '交易方',
    },
    coOrder: {
      coOrder: '合约订单',
      type: '类型',
      contract: '合约',
      nowList1: '时间',
      nowList2: '合约',
      nowList3: '仓位数量(张)',
      nowList4: '委托价格',
      nowList5: '已成交',
      nowList6: '剩余',
      nowList7: '价值',
      nowList8: '成交均价',
      nowList9: '类型',
      nowList10: '状态',
      nowList11: '操作',
      hisList1: '时间',
      hisList2: '合约',
      hisList3: '仓位数量(张)',
      hisList4: '委托价格',
      hisList5: '已成交',
      hisList6: '成交均价',
      hisList7: '类型',
      hisList8: '状态',
      status1: '新订单',
      status2: '完全成交',
      status3: '部分成交',
      status4: '已取消',
      status5: '待撤销',
      status6: '已废弃',
      status7: '部分成交已撤销',
      orderType1: '永续',
      orderType2: '当周',
      orderType3: '次周',
      orderType4: '月度',
      orderType5: '季度',
      infoOrder: '限价单',
      marketOrder: '市价单',
      cancel: '撤单',
    },
  },
  otcRelease: {
    title: '发布一个交易广告',
    text1: '如果您经常交易此币种，可以发布自己的交易广告。如果您只想购买或者出售一次，我们建议您直接从购买或出售列表中下单交易。',
    text2: '如果发布出售广告请保证账户余额充足。',
    text3: '发布交易广告的 用户每笔完成的交易需要缴纳一部分的费用，具体费用以实际为准。',
    text4: '按市场价定价，成交价格可根据市场行情灵活变动，固定价格则不可更改。',
    text5: '所有交流建议在本站上进行，以避免不必要的风险。',
    type: '广告类型',
    buy: '购买',
    sell: '出售',
    currency: '货币类型',
    currencyError: '请选择货币类型',
    countryType: '订单服务国家地区',
    countryError: '请选择订单服务国家地区',
    volume: '数量',
    Surplus: '剩余',
    CurrentUnitPrice: '市场参考价',
    ReferenceWebSite: '参照网址',
    PricingMethod: '定价方式',
    PricingMethodError: '请选择货币类型',
    CustomPrice: '自定义价格',
    TotalSum: '总金额',
    MinimumQuota: '最小限额',
    MaximumQuota: '最大限额',
    min: '分钟',
    TimeLimitForPayment: '付款时限',
    MinimumNumber: '对方最少交易次数',
    frequency: '次',
    FailureTime: '失效时间',
    FailureTimeError: '请选择失效时间',
    PaymentMethod: '支付方式',
    PaymentMethodWarning: '最多可选择3种付款方式',
    Receivables: '收款方式',
    ReceivablesWarning: '可选择多种收款方式',
    PaymentError: '您还没有收款方式，请前往个人中心设置',
    AutomaticRecovery: '自动回复(非必填)',
    AdvertisingMessage: '广告留言(非必填)',
    submit: '发布广告',
    Reminder: '温馨提示',
    AnotherOne: '再发一条',
    goHall: '返回广告大厅',
    success: '恭喜您，广告发布成功。',
    SafetyTips: '安全提示',
    MarketPrice: '市场价(溢价)',
    Custom: '自定义',
    PleaseEnterQuantity: '请输入数量',
    availableBalance: '可用余额不足',
    minPriceError1: '最小限额不得大于总金额',
    minPriceError2: '最小限额不得大于或等于最大限额',
    maxPriceError1: '最大限额不得大于总金额',
    maxPriceError2: '最大限额不得小于或等于最小限额',
    paymentTimeLimit: '请输入付款时限',
    paymentTimeError: '付款时限应当在 10-20 分钟',
    jurisdictionTitle: '请完成实名认证，设置昵称才能发布广告',
    jurisdictionTitle2: '请完成实名认证，设置昵称并申请成为商家才能发布广告',
    authentication: '实名认证',
    DeCertification: '去认证',
    SetNickname: '设置昵称',
    ToSetUp: '去设置',
    ApplicationMerchant: '申请商户',
    ToApply: '去申请',
    threePayment: '最多可以选择三种支付方式',
    day: '天',
    higher: '高于参考价',
    lower: '低于参考价',
    precent: '溢价百分比',
    des: '综合参考主流交易所及行情网站的实时汇率，定时更新',
    precentWay: '溢价方向',
    precentError: '溢价百分比不得大于50.00%',
  },
  otcTrade: {
    warning: '为了保障资金安全，买入的资产将锁定至24h后支持提币和法币卖出等出金操作，在此期间不影响交易等业务',
    inLine: '在线',
    outLine: '离线',
    TransactionTimes: '交易次数',
    CreditDegree: '信用度',
    his: '历史成交(折合BTC)',
    price: '单价',
    volume: '数量',
    TradingLimit: '交易限额',
    TimeLimitPayment: '付款时限',
    MerchantRemarks: '商家备注',
    min: '分钟',
    closeTitle: '关闭广告',
    closeWarning: '关闭广告将不再进行交易，您确认关闭此广告吗 ',
    goHall: '返回法币交易大厅',
    close: '关闭广告',
    PurchaseAmount: '购买金额',
    AmountSale: '出售金额',
    all: '全部',
    pass: '资金密码',
    passError: '请输入8～20位,至少包括数字+字母',
    ImmediateSale: '立即出售',
    ImmediatePurchase: '立即购买',
    CountDown: '倒计时',
    numberError: '下单金额大于该订单数量',
    numberMinError: '换取数量不得小于最小交易限额',
    numberMaxError: '换取数量不得大于最大交易限额',
    OrderAmount: '下单金额',
    ScopeOrderAmount: '下单金额范围',
    QuantityInExchange: '换取数量',
    use: '使用',
    sell: '出售',
    buy: '购买',
    TransactionMode: '交易方式',
    payment: '付款方式',
    Receivables: '收款方式',
    none: '无',
  },
  otcDetailOrder: {
    goPay: '去支付',
    CancellationOrder: '取消订单',
    WaitingPayment: '待买家付款',
    WaitingPuttingMoney: '待卖家放币',
    ConfirmReleaseMoney: '确认收款并放币',
    SubmitAcomplaint: '提交申诉',
    goHall: '返回法币大厅',
    OrderClosed: '订单已关闭',
    OrdersAppeal: '正在申诉',
    CancellationComplaint: '取消申诉',
    OrderException: '订单异常',
    ConfirmPayment: '确认付款',
    MarkedAsPaid: '标记为已付款',
    NotYetPaid: '还未付款',
    payWarning: '本平台不支持自动扣款，请您本人向以上账号自行转账',
    PaymentAmount: '支付金额',
    PaymentReference: '付款参考号',
    Otherparty: '对方',
    ConfirmReleaseMoneyTitle: '取消订单',
    ConfirmReleaseMoneyWarning: '请务必登录账号确认收到该笔款项',
    pass: '资金密码',
    passError: '请输入8～20位,至少包括数字+字母',
    ConfirmReleaseMoneyConfrim: '我确认已登录收款账户，并核对收款无误',
    CancellationOrderTitle: '取消订单',
    CancellationOrderWarning1: '取消订单后不会退款，如您已付款，请勿取消订单。',
    CancellationOrderWarning2: '取消规则：买方当日累计取消3笔订单，将会限制当日买入功能',
    CancellationOrderConfrim: '我确定还没付款给对方',
    AppealTitle: '申诉',
    AppealWarning: '如果订单遇到纠纷，可以通过申诉渠道解决。',
    ReasonsAppeal: '申诉理由',
    CancellationComplaintTitle: '取消申诉',
    CancellationComplaintConfrim: '取消申诉代表您对此订单无争议，您确定取消申诉吗？',
    AppealTitleFive: '确认付款5分钟后才可提交申诉',
    PendingPayment: '待买家付款',
    CountdownPayments: '付款倒计时',
    WaitingCountdownPayment: '待买家付款 倒计时',
    MoneyCollected: '待卖家放币',
    MoneyCollectedWarning: '待卖家确认收款并放币后，您将收到对应的金额',
    otherPartyPaid1: '买家已付款',
    otherPartyPaid2: '标记为',
    otherPartyPaid3: '成功付款',
    Completedbuy1: '订单已完成',
    Completedbuy2: '您可通过',
    Completedbuy3: '查看资产',
    Completedbuy4: '划转至现货账户进行交易',
    CoCompletedbuy4: '划转至主账户进行交易',
    Completedsell: '订单已完成',
    TitleOrderClose: '订单已关闭',
    TitleOrderClose_buyer: '买家取消，订单已关闭',
    TitleOrderClose_timeout: '超时取消，订单已关闭',
    TitleComplaint: '申诉中',
    TitleComplaintText: '我们的客服人员正在积极为您处理，请您耐心等待处理结果。',
    TitleOrderException: '订单异常',
    AfterAppealbuy1: '订单已完成',
    AfterAppealbuy2: '您可通过',
    AfterAppealbuy3: '查看资产',
    AfterAppealbuy4: '划转至现货账户进行交易',
    CoAfterAppealbuy4: '划转至主账户进行交易',
    AfterAppealsell: '订单已完成',
    barText: '已拍下',
    bar1Buy1: '待买家付款',
    bar1Buy2: '待卖家放币',
    bar1Sell1: '待买家付款',
    bar1Sell2: '待卖家放币',
    bar2Buy1: '买家已付款',
    bar2Buy2: '待卖家放币',
    bar2Sell1: '买家已付款',
    bar2Sell2: '待卖家放币',
    bar3Buy1: '买家已付款',
    bar3Buy2: '卖家已放币',
    bar3Sell1: '买家已付款',
    bar3Sell2: '卖家已放币',
    bar4Sell: '已关闭',
    bar5Sell: '申诉中',
    bar7Sell: '异常订单',
    bar8Buy1: '买家已付款',
    bar8Buy2: '卖家已放币',
    bar8Sell1: '买家已付款',
    bar8Sell2: '卖家已放币',
    day: '天',
    hour: '时',
    min: '分',
    sec: '秒',
    SellersPaymentMethod: '卖家支付方式',
    paysBuy2: '您已付款，无法查看对方支付信息',
    paysBuy3: '您已付款，无法查看对方支付信息',
    paysSell3: '订单已完成，无法查看支付信息',
    pays4: '订单已关闭，无法查看支付信息',
    pays5: '订单申诉中，无法查看支付信息',
    pays7: '订单异常，无法查看支付信息',
    paysBuy8: '您已付款，无法查看对方支付信息',
    paysSell8: '订单已完成，无法查看支付信息',
    MessPaymentReference: '付款参考号',
    MessPrice: '单价',
    MessVolume: '数量',
    MessTotol: '总价',
    MessMerchantRemarks: '商家备注',
    none: '无',
    chatServer: '客服',
    chatUser: '商家',
    chatServerMessage: '系统消息：您已成功提交申诉，请耐心等待。',
    chatServerInp: '请输入信息',
    chatServerBut: '发送',
    inline: '在线',
    outline: '离线',
    chatVolume: '成交量',
    chatUserInp: '请输入信息',
    chatUserBut: '发送',
    identification: '实名信息',
    connection: '联系方式',
    phone: '手机号码',
    twoMin: '买家付款2分钟后可查看',
  },
  components: {
    alert: {
      buttonText: '我知道了',
    },
    dialog: {
      confirmText: '确定',
      closeText: '取消',
    },
    getCode: {
      button: '获取验证码',
      after: '后重新获取',
    },
    select: {
      noData: '暂无数据',
    },
    otcReminder: {
      title: '温馨提示',
      text1: '1、在转账过程中请勿备注类似BTC、USDT、平台信息、数字货币信息等，防止造成您的汇款被拦截、银行卡被冻结等问题，因此到账延迟，卖方可选择拒绝成交。',
      text2: '2、请使用平台实名的银行卡、支付宝等进行转款，否则卖家可拒绝成交并投诉。',
      text3: '3、若交易金额大于50,000 CNY，法定假日或工作日17:00点以后汇款到银行卡可能造成到账不及时，请分批支付保证及时到账，若未及时到账，卖家有权拒绝成交。',
      text4: '4.若您已完成付款，请务必点击“我已付款’按钮，卖家确认收款后，您就会收到数字资产。',
    },
  },
  manageFinances: {
    manage_finances: '理财宝',
    subTitle: '自动分散投资工具，省时 省力 更省心',
    record: '理财记录',
    day: '天',
    recommend: '精选推荐',
    safe: '安全保障',
    expected: '预期',
    rate: '收益率',
    timeLimit: '期限',
    people: '人次',
    join: '累计加入',
    now: '立即赚钱',
    yearRate: '年化',
    dayRate: '日化',
    moreProducts: '查看更多产品',
    Repayment: '还款方式',
    ReleaseCycle: '释放周期',
    deadline: '项目截止时间',
    startTime: '计息开始时间',
    exitTime: '到期退出时间',
    times: '次',
    availableBalance: '可用余额',
    goRecharge: '充值',
    buyNumber: '购买数量',
    feature: '您的预期收益',
    commonProblem: '常见问题',
    buyNow: '立即购买',
    what: '什么是理财宝？',
    what_1: '什么是币多多？',
    how: '如何参与？',
    rule: '理财产品返还规则？',
    rule_1: '币多多返还规则？',
    forSafe: '为了您的账户安全，请先开启实名验证。',
    goAuth: '去验证',
    note1: '理财宝是BIKI平台推出的一项基于数字资产的固定周期理财币产品，每个计划都有相应的锁仓期限和预期年化收益率，您可以自由选择认购，购买后本金锁定，根据约定时间开始计算收益，计划到期后本金和收益解冻转入账户，您即可获得约定的收益。',
    note1_1: '币多多是WBFex平台推出的一项基于数字资产的固定周期理财币产品，每个计划都有相应的锁仓期限和预期年化收益率，您可以自由选择认购，购买后本金锁定，根据约定时间开始计算收益，计划到期后本金和收益解冻转入账户，您即可获得约定的收益。',
    note2: '登录Biki数字资产交易所官网www.biki.com，在资产管理点击“去理财”按钮，依据您自身的情况选择需要的产品，输入币数量，点击“立即加入”，即可参与理财宝。',
    note2_1: '登录WBFex数字资产交易所官网new.WBFex.com，在资产管理点击“去理财”按钮，依据您自身的情况选择需要的产品，输入币数量，点击“立即加入”，即可参与币多多。',
    note3: '根据先息后本的返还规则，即在产品锁定周期内，首次返还周期为三周，三周后返还三倍利息，之后固定每周返还一次利息，产品到期后归还本金。',
    inputNumber: '请输入购买数量',
    buyNumMax: '购买数量不得大于可用余额',
    first: '先息后本',
    together: '本息一起',
    buyTime: '购买时间',
    name: '项目名称',
    orderNumber: '订单号',
    coin: '币种',
    number: '数量',
    tablerate: '利率(%)',
    status: '状态',
    operating: '操作',
    transferTime: '返还时间',
    returnCoin: '返还币种',
    returnNumber: '返还数量',
    type: '类型 ',
    allType: '全部类型',
    subscribed: '已认购',
    interested: '计息中',
    completed: '已完成',
    interest: '利息',
    principal: '本金',
  },
  footer: {
    terms: '条款',
    agreement: '用户协议',
    declaration: '法律声明',
    aboutChainup: '关于',
    utils: '工具',
    about: '关于ChainUP',
    apply: '上币申请',
    download: '客户端下载',
    api: 'API文档',
    media: '社交媒体',
  },
  appDownLoad: {
    text1: '安卓下载',
    text2: '扫码下载',
    text3: 'Google Play',
    text4: '立即下载',
    text5: '下载地址',
    text6: '苹果下载',
    text7: '国际 Apple ID',
    text8: 'TestFlight',
    text9: '安装教程',
    title: '下载APP客户端',
    desc: '随时随地 多平台终端交易',
    platform: [
      'iPhone',
      'Android',
    ],
    twoDimension: '扫描二维码下载',
    headerCode: '扫描下载APP',
    moreDown: '更多下载',
    flag: [
      {
        title: '闪电交易性能',
        desc: '提供多样交易类型选择，订单极速撮合，一键闪兑，买卖更便捷',
      },
      {
        title: '资产轻松划转',
        desc: '轻松划转账户内资产，实时的数字资产概览，增加币种占比饼图',
      },
      {
        title: '自定义交易面板',
        desc: '根据不同交易习惯自由定义交易布局，增加K线与深度图入口',
      },
      {
        title: '账户集成管理',
        desc: '多重安全验证设置，一个账户管理法币账户与现货账户',
      },
    ],
    setUp: {
      title: 'iOS 用户安装教程',
      step: [
        {
          step: 1,
          title: '下载APP',
          desc: '在手机中打开设置功能，选择"通用"；',
        },
        {
          step: 2,
          title: '设备管理',
          desc: '在通用中，选择"描述文件与设备管理"功能；',
        },
        {
          step: 3,
          title: '选择安装',
          desc: '在描述文件与设备管理中的企业级应用分类中，选择要安装的企业应用的文件名称（与打开时的提示一致），点击进入；',
        },
        {
          step: 4,
          title: '设置信任',
          desc: '进入企业签名页面后，确认企业签名中的公司名称与应用名称后，点击信任"企业签名公司名称"；',
        },
        {
          step: 5,
          title: '启动APP',
          desc: '回到桌面，重新打开应用即可使用。',
        },
      ],
    },
    setUpTestFlignt: {
      title: 'iOS 用户安装教程',
      step: [
        {
          step: 1,
          title: '下载APP',
          desc: '点击【安装 TestFligh】，按照页面提示进行，打开APP Store中下载TestFlight"；',
        },
        {
          step: 2,
          title: '下载TestFlight',
          desc: '您也可以直接登录APP Store中下载TestFlight，如您已下载，请忽略',
        },
        {
          step: 3,
          title: '选择安装',
          desc: '打开TestFlight APP，接受Cobidex Beta版本，打开即可使用；如您已经下载可用进行【更新】获取最新版本',
        },
      ],
    },
    download_text_1: 'IOS企业签',
    download_text_2: '安卓APK',
    download_text_3: 'TestFlight',
    download_text_4: 'Google Play',
  },
  homeTemplate: {
    text_01: '随时随地 多平台终端交易',
    text_02: '覆盖iOS、Android、Windows、Mac多个平台，支持全业务功能',
    text_03: '下载客户端',
    text_04: '产品与服务',
    text_05: '为全球数百万用户提供安全、可信赖的数字资产交易及资产管理服务',
    text_06: '全球化布局',
    text_07: '多个国家设立本土化交易服务中心打造多业务形态为一体',
    text_08: '安全体系',
    text_09: '一流团队打造专业安全多重防御让您资产无忧',
    text_10: '交易系统',
    text_11: '多个国家设立本土化交易服务中心打造多业务为一体',
    text_12: '高扩展性',
    text_13: '资产流转快速交易畅通无阻',
    text_14: '马上开启交易之旅',
    text_15: '提供币币、法币、合约交易等全面数字资产业务',
    text_16: '立即注册',
    text_17: '多平台终端交易',
    text_18: '您身边的资产管家',
    text_19: '立即开始',
    text_20: '立即注册',
    text_21: '电子邮件地址 / 电话号码',
    products: {
      text_1: '核心产品',
      text_2: '一站式满足您的所有需求',
      text_3: '合约交易',
      text_4: '支持USDT永续合约，多空双开，随时获利',
      text_5: '现货交易',
      text_6: '支持100+加密货币交易，操作简单便捷',
      text_7: '法币交易',
      text_8: '充值加密货币，立刻开启交易，支持多种支付方式',
      text_9: '立即交易',
    },
    steps: {
      text_1: '1分钟，轻松上手',
      text_2: '立刻开启您的交易之旅',
      text_3: '注册帐户',
      text_4: '随时随地注册账户',
      text_5: '充值入金',
      text_6: '充值加密货币到您的账户，支持多方式充值入金',
      text_7: '实名认证',
      text_8: '完成实名认证，保护您的账户资产安全',
      text_9: '准备就绪，享受您的加密交易之旅吧！',
    },
    services: {
      text_1: '产品和服务',
      text_2: '为全球数百万用户提供安全可靠的数字资产交易和资产管理服务',
      text_3: '顶级交易系统',
      text_4: '全球技术团队，分布式并行技术，高速匹配引擎，流畅的交易体验',
      text_5: '顶级风控系统护航',
      text_6: '行业领先的风险控制系统，确保资金安全无忧',
      text_7: '丰富的产品功能',
      text_8: '高杠杆合约产品、多币种现货交易、快捷出入金',
      text_9: '卓越的客户服务',
      text_10: '多语言、多渠道服务系统，随时为您答疑解惑',
    },
    text_22: '立即交易',
    text_23: '立即完成注册，开始交易',
    footer: {
      title_1: '关于我们',
      title_2: '帮助',
      title_3: '服务',
      title_4: '产品',
      text_1_1: '关于exchange',
      text_1_2: '公告中心',
      text_1_3: '用户协议',
      text_1_4: '隐私条款',
      text_1_5: '风险提示',
      text_1_6: '免责声明',
      text_2_1: '帮助中心',
      text_2_2: '费率标准',
      text_2_3: '合约指南',
      text_3_1: '在线客服',
      text_3_2: '提交工单',
      text_3_3: '上币申请',
      text_3_4: '商家申请',
      text_3_5: '客户端下载',
      text_4_1: '现货交易',
      text_4_2: '合约交易',
      text_4_3: '法币交易',
    },
    text_24: '覆盖iOS、Android多个平台，支持全业务功能',
  },
  lever: {
    leverAccount: '杠杆资产',
    leverKy: '可用',
    leverKj: '可借',
    leverYj: '已借',
    leverjd: '借贷',
    fxl: '风险率',
    leverText1: '总资产/借贷资产*100%',
    leverText2: '当风险率≤110%时，账户将触发爆仓以归还借贷资金',
    bcj: '爆仓价',
    leverHz: '划转',
    leverJd: '借贷',
    leverZded: '最大额度',
    leverLl: '利率',
    all: '全部',
    leverJdcc: '借贷成功',
    leverJdNumber: '借贷数量',
    buy: '买入/做多',
    sell: '卖出/做空',
    alertTitle: '温馨提示',
    your: '您的',
    alertTet: '杠杆账户余额不足，需转入资产方可进行杠杆交易。',
    hzBtntext: '立即划转',
  },
  contract: {
    co: '合约',
    co2: '合约',
    contractType1: '永续',
    contractType2: '当周',
    contractType3: '次周',
    contractType4: '月度',
    contractType5: '季度',
    applies: '涨跌幅',
    height: '最高价',
    low: '最低价',
    H_volume: '24H成交量',
    handicap: '盘口',
    latestDeal: '实时成交',
    number: '目前仓位数量',
    price: '价格',
    total: '总量',
    time: '时间',
    volume: '成交数量',
    addEnsure: '增加保证金',
    minusEnsure: '减少保证金',
    fqEnsure: '已分配保证金',
    kyEnsure: '可用保证金',
    addMinusEnsure: '增加&减少保证金',
    addEnsureNumbere: '增加保证金数量',
    minusEnsureNumbere: '减少保证金数量',
    infoOrder: '限价单',
    marketOrder: '市价单',
    cancel: '撤单',
    closePrice: '市价平仓',
    limitPrice: '限价平仓',
    contractId: '合约ID',
    accountId: '仓位ID',
    coNumber: '仓位数量',
    piece: '张',
    holding: '持有仓位',
    currentEntrust: '当前委托',
    dayTrading: '当日成交',
    historyEntru: '历史委托',
    nowList1: '时间',
    nowList2: '合约',
    nowList3: '仓位数量(张)',
    nowList4: '委托价格',
    nowList5: '已成交',
    nowList6: '剩余',
    nowList7: '价值',
    nowList8: '成交均价',
    nowList9: '类型',
    nowList10: '状态',
    nowList11: '操作',
    nowList12: '成交价格',
    nowList13: '开仓价格',
    nowList14: '标记价格',
    nowList15: '强平价格',
    nowList16: '未实现盈亏',
    nowList17: '已实现盈亏',
    nowList18: '回报率',
    nowList19: '保证金',
    nowList20: '委托ID',
    status1: '新订单',
    status2: '完全成交',
    status3: '部分成交',
    status4: '已取消',
    status5: '待撤销',
    status6: '已废弃',
    status7: '部分成交已撤销',
    c_success: '下单成功',
    cancel_success: '撤单成功',
    c_error: '操作失败',
    cost: '成本',
    orders: '委托价值',
    balance: '可用余额',
    entryPrice: '开仓价格',
    liquidationPrice: '强平价格',
    bjPrice: '标记价格',
    liquidationPriceTwo: '预估爆仓价',
    value: '价值',
    chiccw: '持仓仓位',
    multipleb: '杠杆倍数',
    marketPrice: '市价',
    cw: '仓位',
    rate: '回报率',
    buyButton: '买入/做多',
    sellButton: '卖出/做空',
    loginReg: '登录/注册',
    buy: '买入',
    sell: '卖出',
    errorText_01: '仓位数量最大可输入',
    errorText_02: '仓位数量最小可输入',
    limitPriceTrade: '限价交易',
    marketPriceTrade: '市价交易',
    deliveryTime: '距离交割还有',
    day: '天',
    success: '成功',
    pleprice: '请输入平仓价格',
    Value: '价值',
    Chiccw: '你的位置',
    Multipleb: '杠杆',
    Piece: '张',
    closeToMark: '触发价格距离标记价格较近，委托失败。',
  },
  tradeLimt: {
    tradeLimit_text_everyDayCount: '该币对限制每日交易数量，',
    tradeLimit_text_everyDayBuy: '单日最大买入量为：',
    tradeLimit_text_everyDaySell: '单日最大卖出量为：',
    tradeLimit_text_noLimitBuy: '未限制买入交易，',
    tradeLimit_text_noLimitSell: '未限制卖出交易。',
    tradeLimit_text_instructions: '交易须知',
    tradeLimit_text_everyDayBuy_end: ' ',
    tradeLimit_text_everyDaySell_end: ' ',
  },
  market: {
    allMarket: '全部行情',
    text1: '概况',
    text2: '去交易',
    text3: '基本信息',
    vol: '量',
    noDataDesc: '暂无收藏，前往市场添加',
    noData: '暂无数据',
    addFavorites: '添加自选',
    exchange: '现货',
    futures: '永续合约',
  },
  kyc: {
    success: '提交成功',
    error: '认证失败',
    text1: '无法达到认证要求，请返回个人中心重新提交实名申请',
    text2: '账号已存在实名认证信息，不能再提交实名申请。',
    text3: '被认证的实名信息不能重复认证',
    text4: '您的信息已提交，审核时长为1分钟，您可以在“用户中心”页面查看结果。',
  },
  weeks: {
    0: '星期日',
    1: '星期一',
    2: '星期二',
    3: '星期三',
    4: '星期四',
    5: '星期五',
    6: '星期六',
  },
  months: {
    0: '1月',
    1: '2月',
    2: '3月',
    3: '4月',
    4: '5月',
    5: '6月',
    6: '7月',
    7: '8月',
    8: '9月',
    9: '10月',
    10: '11月',
    11: '12月',
  },
  mobilityTrade: {
    addPrice: '请输入金额',
    addVolume: '请输入数量',
    priceSell: '按金额出售',
    smallAmount: '小额快速交易，0手续费',
    tradeType: '类型',
    immediately: '一键买币',
    immediatelyBuy: '一键购买',
    immediatelySell: '一键出售',
    priceBuy: '按金额购买',
    volumeBuy: '按数量购买',
    volumeSell: '按数量出售',
    referencePrice: '参考单价',
    referenceWarn: '该价格参考市场主流交易所主流币对计算得出，非最终成交价，仅供参考',
    coin: '币种',
    legal: '法币币种',
    all: '全部',
    buyPayments: '选择付款方式',
    sellPayments: '选择收款方式',
    addPayments: '添加收款方式',
    noPayments: '没有收款方式，请前往个人中心设置',
    tradePrice: '成交单价',
    tradeVolume: '成交数量',
    tradeSum: '实付金额',
    warn: '由于市场行情波动，为您匹配出的价格可能会发生小幅波动，请您尽快下单及时锁定价格！',
    btnHis: '报价已过期，点击获取最新价格',
    warn1: '输入购买金额后获取',
    warn2: '输入购买数量后获取',
    warn3: '输入出售金额后获取',
    warn4: '输入出售数量后获取',
    error1: '最大下单金额为',
    error2: '下单金额范围为',
    error3: '最大下单数量为',
    error4: '下单数量范围为',
    error5: '未找到合适报价，请修改下单条件',
    error6: '请您先添加收款方式',
  },
  freeStaking: {
    incomeFilter: [
      '理财收益到账',
      '理财本金锁仓',
      '理财本金释放',
    ],
    home: {
      status: [
        '待开始',
        '募集中',
        '待计息',
        '计息中',
        '计息结束',
        '本金释放',
        '已满额',
        '已结束',
      ],
      notice: '查看公告',
      title: '持币返利类型',
      gainRate: '预期年化收益率',
      lockDay: '锁仓天数',
      lockProgress: '锁仓进度',
      takeActivity: '查看活动',
      contactUS: '联系我们',
      FQA: '常见FAQ',
      income: '收益',
    },
    detail: {
      activityProgress: '活动进度',
      lockAllNum: '锁仓总额',
      lockNum: '锁仓数量',
      lockMinNum: '单次锁仓最低数量：',
      lockMaxNum: '累计锁仓不超过：',
      userLocked: '您已锁仓',
      twoDayIncome: [
        '日',
        '预计收益：',
      ],
      totalGainAmount: '平台累计发放',
      totalUserGainAmount: '您已经获得',
      rulesDangers: '本人承诺已充分知晓项目风险',
      agreePOS: '同意PoS',
      activityStatus: [
        '募集开始',
        '募集截止',
        '计息开始',
        '计息停止',
        '本金释放',
      ],
      incomeTime: '收益时间',
      incomeNum: '收益数量',
      incomeDetail: '收益明细',
      balanceError: [
        '锁仓数量不得超过您账户中',
        '的数量',
      ],
      buyAmountMinError: [
        '不得小于单次最小数量',
      ],
      buyAmountMaxError: [
        '累计锁仓不超过',
      ],
      buySuccess: '购买成功',
    },
    myPos: {
      lockPosTable: [
        '币种',
        '锁仓开始时间',
        '锁仓数量',
        '预期年化收益率',
        '当前锁仓收益',
        'PoS状态',
      ],
      unLockPosTable: [
        '币种',
        '收益日期',
        '本金',
        '年化收益率',
        '收益数量',
      ],
      lockPOS: '协议PoS',
      havePOS: '持仓PoS',
      endTime: '截止时间',
    },
  },
  singPassLogin: {
    mainText1: '其他登录方式',
    mainText2: 'SingPass第三方登录',
    mainText3: '二维码已失效',
    mainText4: '请点击刷新',
    mainText5: '打开',
    mainText6: '手机SingPass',
    mainText7: '扫一扫登录',
    mainText8: '还没有SingPass App？',
    mainText9: '去下载',
    mainText10: '您尚未关联交易所账号，请选择关联方式',
    mainText11: '关联新账号',
    mainText12: '关联现有账号',
    mainText13: '登录并关联SingPass账号',
    mainText14: '注册并关联SingPass账号',
    mainText15: 'SingPass第三方注册',
  },
  registerOptions: {
    title: '安全提醒',
    text: '由于运营商网络不稳定，您当前所在地区短信接收可能会有延迟，推荐您使用谷歌验证',
    conf: '绑定谷歌',
    close: '仍绑定手机',
  },
  futures: {
    currentSymbol: {
      title1: '标记价格',
      title2: '指数价格',
      title3: '本期资金费率',
      title4: '预测下期资金费率',
      title5: '24H成交量',
      explain1: '标记价格用于结算盈亏和触发强制平仓。标记价格可能会偏离市场最新价格，以防因市场被恶意操纵造成损失。',
      explain2: '标的货币的市场公允现货价格。',
      explain3: '本期结束资金费率时将以此值进行结算。',
      explain4: '资金费每8小时结算一次（仅针对持仓用户），分别为UTC时间00:00，08:00，16:00<br />资金费用=结算点实时资金费率*仓位价值 <br />仓位价值=仓位张数*面值*标记价格',
      explain5: '下期结算资金费时预计以此值进行结算。',
      explain6: '资金费率为正则多头支付空头资金费，资金费率为负则空头支付多头资金费。',
      marginModel1: '全仓',
      marginModel2: '逐仓',
    },
    depth: {
      text1: '委托列表',
      text2: '实时成交',
      text3: '指数',
      text4: '深度',
      text5: '标记',
      theadList1: '价格',
      theadList2: '数量',
      theadList3: '总计',
    },
    market: {
      text1: '合约',
      text2: '最新价',
      text3: '涨跌幅',
      text4: 'USDT合约',
      text5: '币本位合约',
      text6: '混合合约',
      text7: '模拟合约',
      text8: '搜索币种',
    },
    newTrade: {
      text1: '实时成交',
      text2: '价格',
      text3: '数量',
      text4: '时间',
    },
    orderList: {
      tabType1: '仓位',
      tabType2: '普通委托',
      tabType3: '条件委托',
      tabType4: '历史委托',
      tabType5: '资金流水',
      subTabType1: '所有',
      subTabType2: '止损单',
      subTabType3: '止盈单',
      a_columns_1: '合约',
      a_columns_2: '方向',
      a_columns_3: '数量',
      a_columns_4: '完成度',
      a_columns_5: '委托价格',
      a_columns_6: '成交均价',
      a_columns_7: '类型',
      a_columns_8: '只减仓',
      a_columns_9: '时间',
      a_columns_10: '操作',
      b_columns_1: '合约',
      b_columns_2: '方向',
      b_columns_3: '触发价格',
      b_columns_4: '委托价格',
      b_columns_5: '委托数量/价值',
      b_columns_6: '类型',
      b_columns_7: '只减仓',
      b_columns_8: '提交时间',
      b_columns_9: '过期时间',
      c_columns_1: '合约',
      c_columns_2: '类型',
      c_columns_3: '方向',
      c_columns_4: '委托价格',
      c_columns_5: '委托数量/价值',
      c_columns_6: '成交数量',
      c_columns_7: '成交均价',
      c_columns_8: '盈亏',
      c_columns_9: '状态',
      c_columns_10: '时间',
      c_columns_11: '手续费',
      d_columns_1: '时间',
      d_columns_2: '类型',
      d_columns_3: '金额',
      d_columns_4: '币种',
      typeStatus1: '限价单',
      typeStatus2: '市价单',
      typeStatus3: '只做maker',
      typeStatus4: '强制平仓',
      typeStatus5: '仓位合并',
      getStatus1: '新订单',
      getStatus2: '完全成交',
      getStatus3: '部分成交',
      getStatus4: '已取消',
      getStatus5: '待撤销',
      getStatus6: '异常订单',
      getStatus7: '部分成交已撤销',
      sideT1: '开',
      sideT2: '平',
      sideT3: '空',
      sideT4: '多',
      mPrice: '市价',
      isclose1: '是',
      isclose2: '否',
      cancel: '取消',
      allCancel: '全部取消',
      close_all_position: '一键全平',
      close_all_tip: '一键全平将会撤销U本位合约下所有挂单，并以市价委托方式平仓U本位合约下所有仓位。请确认是否一键平仓？',
      tstext1: '请',
      tstext2: '登录/注册',
      tstext3: '再进行操作',
      memoText1: '用户撤销',
      memoText2: '订单异常，被系统撤销',
      memoText3: '仓位发生强平，未成交委托被系统撤销',
      memoText4: '对手盘不足，委托被系统取消',
      memoText5: 'FOK订单，无法全部成交时被系统撤销',
      memoText6: 'IOC订单，无法立即成交时部分委托被系统撤销',
      memoText7: '被动委托，撮合时为taker部分被系统撤销',
      memoText8: '仓位不存在，平仓委托被系统撤销',
      newText1: '盈亏记录',
      newText2: '成交记录',
      newText3: '开仓均价',
      newText4: '平仓均价',
      newText5: '仓位数量',
      newText6: '已实现盈亏',
      newText7: '总盈亏为该仓位持仓期间累计发生的总盈亏，总盈亏 = 手续费+资金费用+仓位盈亏+分摊',
      newText8: '开仓、平仓累计总手续费',
      newText9: '资金费用',
      newText10: '持仓期间的总资金费用',
      newText11: '仓位盈亏为仓位每次平仓的仓位盈亏之和，平仓盈亏根据 平仓前的持仓均价和平仓均价计算得出',
      newText12: '分摊',
      newText13: '平仓时间',
      newText14: '角色',
      newText15: '仓位盈亏',
      newText16: '仅限当前合约',
    },
    tradeForm: {
      mPrice: '市价',
      textjz: '价值',
      text1: '提交委托',
      text2: '可用',
      text3: '可用余额为用户可自由支配的资金。可用余额会优先作为全仓保证金，当全仓仓位亏损时，可用就会减少。',
      text4: '有效期',
      text5: '成本',
      text6: '只减仓',
      text7: '只减仓订单只会减少仓位，不会增加仓位。',
      text8: '价格',
      text9: '数量',
      text10: '张',
      text11: '委托价格',
      text12: '触发价',
      text13: '当该合约的标记价格达到该价格时，系统将按照你设置的下单价格和下单数量为你下单。',
      text14: '开仓价值',
      text15: '需要开的仓位的价值，仓位价值 = 仓位数量 * 成交价格，实际成交的仓位数量与成交时的成交价格有关。',
      text16: '24H',
      text17: '7天',
      text18: '14天',
      text19: '30天',
      text20: '开仓',
      text21: '平仓',
      text22: '限价单',
      text23: '市价单',
      text24: '条件单',
      text25: '可平空',
      text26: '可平多',
      text27: '可买',
      text28: '可卖',
      text29: '只做maker',
      text30: '只做Maker（Post-Only）订单保证用户只做maker，该订单不会立即在市场成交，假如此委托会立即与已有委托单成交，那么此委托单将被立即取消。',
      text31: 'IOC（Immediately or Cancel）订单若不能立即成交则立即取消未成交的部分。',
      text32: 'FOK（Fill or Kill）订单若不能全部成交则立即全部取消。',
      text33: '开通合约交易',
      text34: '登录后进行交易',
      text35: '买入平空',
      text36: '卖出平多',
      text37: '买入开多',
      text38: '卖出开空',
      text39: '买入做多',
      text40: '卖出做空',
      text41: '价格偏差太大！',
      text42: '超出单次最大下单金额，最多可输入',
      text43: '超出单次最小下单金额，最少需输入',
      text44: '超出单次最大下单量，最多可输入',
      text45: '超出单次最小下单量，最少需输入',
      text46: '超出可平数量！',
      text47: '请输入价格',
      text48: '请输入数量',
      text49: '请输入开仓价值',
      text50: '请输入触发价',
      text51: '保证金余额不足！',
      text52: '当时市场价格',
      text53: '委托数量',
      text54: '本合约当前存在委托，不可调整杠杆',
      text55: '本合约当前存在委托/仓位，不可调整仓位类型',
      text56: '超出最大下单量，最多还可以下单',
      text57: '超出最大下单额度',
      text58: '价格低于最低限定价格',
      text59: '价格高于最高限定价格',
    },
    calculator: {
      text1: '计算器',
      text2: '杠杆倍数',
      text3: '当前杠杆最高可持有头寸数',
      text4: '计算',
      text5: '计算结果',
      text6: '开仓保证金',
      text7: '收益额',
      text8: '回报率',
      text9: '平仓价格',
      text10: '无法达到该收益率',
      text11: '强平价格',
      text12: '开仓价格',
      text13: '平仓价格',
      text14: '数量',
      text15: '张',
      text16: '收益',
      text17: '多仓',
      text18: '空仓',
      text19: '买入做多',
      text20: '卖出做空',
      text21: '仓位数量',
      text22: '保证金数量',
      text23: '保证金不足以开仓',
      text24: '不会被强制平仓',
      text25: '计算结果仅供参考，实际操作中可能会因为手续费，资金费率导致计算结果存在偏差。',
      text26: '全仓',
      text27: '逐仓',
      text28: '可用余额不满足开此仓位最少起始保证金',
      text29: '可用',
      text30: '增加保证金',
    },
    depositMode: {
      text1: '全仓保证金模式: 所有仓位共用合约账户中的保证金来避免仓位被强平。在强平事件中，交易者可能会损失所有的保证金和仓位。',
      text2: '逐仓保证金模式: 一定数量保证金被分配到仓位上。如果仓位保证金亏损到低于维持保证金的水平，仓位将被强平。在逐仓模式下，您可以为这个仓位添加和减少保证金。',
      text3: '设置为全仓模式',
      text4: '设置为逐仓模式',
      text5: '请登录后再进行操作',
      text6: '已是全仓模式',
      text7: '已是逐仓模式',
      text8: '持有仓位/有挂单时不可改变保证金模式',
      text9: '全仓',
      text10: '逐仓',
      text12: '保证金模式',
      tradingMode: '交易模式',
      merge: '合仓',
      split: '分仓',
      position_mode: '仓位模式',
      merge_mode: '合仓模式：同一方向（开多或开空）且同一交易对下单将合并为一个仓位。同一交易对最多只有多仓和空仓两个仓位。同一交易对的所有仓位杠杆只能在下单区域统一调整。调整后 ，持仓仓位会按最新杠杆倍数显示。',
      split_mode: '分仓模式：同一方向（开多或开空）且同一交易对下可开设多个仓位，分仓模式下新开单不会与已有仓位合并，同一交易对可有多个多仓和空仓仓位。各仓位可享有独立杠杆倍数，下单区的杠杆倍数只影响新下单的仓位。',
    },
    reminder: {
      text1: '触发价格',
      text2: '价格',
      text3: '下次不要提示，您可在【交易偏好设置】中重新设置',
      text4: '金额',
      text5: '数量',
      text6: '占用保证金',
      text7: '委托保证金',
      text8: '限价单',
      text9: '市价单',
      text10: '条件单',
    },
    lever: {
      text1: '杠杆倍数',
      text2: '当前持仓最高支持杠杆',
      text3: '当前杠杆最高可持有仓位上限约',
      text4: '确认',
      text5: '请登录后再进行操作',
      text6: '本合约有委托单不可调整杠杆',
      text7: '合约杠杆',
      text8: '杠杆倍数最小不能低于',
    },
    openFutures: {
      titleText: '合约开通提醒',
      openTips: '尊敬的用户，您尚未开通永续合约，开通后可进行永续合约相关操作！',
      confirmText: '开通合约',
      cancelText: '暂不开通',
      agreeText: '我已了解合约风险并同意',
      agreeLink: '《永续合约服务协议》',
      question1: '1.您在次交易活动中可能面临的最大盈亏比例是？',
      answer1_1: '盈亏无上限',
      answer1_2: '不到50%',
      question2: '2.如果您在交易中遭受部分资金、甚至全部资金损失，将有谁来承担责任？',
      answer2_1: '仅有您自行承担，因为这是一个由您独自理性做出的选择',
      answer2_2: '由平台承担',
      protocolLink: 'https://exchange.zendesk.com/hc/zh-sg/articles',
    },
    positionLis: {
      columns1: '合约',
      columns2: '仓位/可平',
      columns3: '成本价',
      columns4: '标记价格',
      columns5: '预期强平价格',
      columns6: '保证金',
      columns7: '保证金率',
      columns8: '盈亏/收益率',
      columns9: '操作',
      columns10: '止盈止损',
      textQuickClosing: '快速平仓',
      text1: '输入价格',
      text2: '限价平仓',
      text3: '市价平仓',
      text4: '量',
      text5: '张',
      text6: '仓位： 你当前持有的仓位大小。正数代表多仓，负数代表空仓。 <br /> 可平：剩余待平的仓位数量。提交平仓或只减仓类型的订单会减少可平数量。',
      text7: '该多仓/空仓开仓时的平均买入/卖出价。',
      text8: '标记价格用于结算盈亏和触发强制平仓。标记价格可能会偏离市场最新价格，以防因市场被恶意操纵造成损失。',
      text9: '当标记价格接近这个值时，此仓位会被强制平仓。',
      text10: '用于担保此仓位的资产。逐仓为此仓位的实际担保资产。全仓为当前杠杆下所需的担保资产。',
      text11: '保证金率用于判断仓位强平风险，当保证金率小于等于100%时对应仓位将被执行强平。',
      text12: '仓位未实现盈亏即未平仓位自开仓到现在的浮动盈亏，多仓未实现盈亏=(标记价格-开仓均价)*数量，空仓未实现盈亏=(开仓均价-标记价格)*数量<br />收益率即占用保证金的平均回报率。收益率 = 盈亏 / 占用保证金。',
      text13: '止盈止损订单是指，预先设置触发价、委托价和下单数量，最新价达到触发价，会按委托价挂单，帮助您保住利润或减少损失。',
      text14: '全仓',
      text15: '逐仓',
      text16: '空',
      text17: '多',
      text18: '请输入价格',
      text19: '请输入数量',
      text20: '超出可平数量',
      text21: '卖出平多',
      text22: '买入平空',
      text23: '市价',
      text24: '输入数量',
      text25: '输入张数',
      text26: '已结算盈亏',
      text27: '已实现盈亏为已经结算到用户余额中的收益，包含交易手续费、资金费用、平仓盈亏、结算收益等。',
      text28: '手续费',
      text29: '平仓盈亏',
      text30: '资金费用',
      text31: '持仓结算',
      text32: '分摊',
    },
    setFutures: {
      titleText: '交易设置',
      text1: '持仓类型',
      text2: '持有任何合约仓位/有挂单时不可更改持仓类型',
      text3: '单向持仓',
      text4: '单向持仓模式下，一个合约只允许持有一个方向的仓位',
      text5: '双向持仓',
      text6: '双向持仓模式下，一个合约可允许同时持有多空两个方向的仓位，并且同一合约下不同方向仓位风险对冲',
      text7: '下单前弹框确认',
      text8: '开启',
      text9: '关闭',
      text10: '合约单位',
      text11: '张',
      text12: '确定',
      text13: '条件单/止盈止损有效期',
      text14: '下单前弹框确认',
    },
    setMarginCoin: {
      titleText: '调节逐仓仓位保证金',
      text1: '当前',
      text2: '变更后',
      text3: '仓位',
      text4: '仓位保证金',
      text5: '实际杠杆',
      text6: '强平价',
      text7: '可用',
      text8: '可减少保证金',
      text9: '全部',
      text10: '增加保证金',
      text11: '减少保证金',
      text12: '增加保证金数量',
      text13: '减少保证金数量',
      text14: '余额不足',
      text15: '可减少保证金不足',
    },
    stopOrder: {
      titleText: '止盈止损',
      text1: '止盈',
      text2: '撤销所有止盈单',
      text3: '止盈价需大于标记价格',
      text4: '止盈价需小于标记价格',
      text5: '预计盈亏',
      text6: '预计收益率',
      text7: '止损',
      text8: '撤销所有止损单',
      text9: '止损价需小于标记价格，大于强平价格',
      text10: '止损价需大于标记价格，小于强平价格',
      text11: '预计盈亏',
      text12: '预计收益率',
      text13: '止盈触发价',
      text14: '委托价格',
      text15: '委托数量',
      text16: '张',
      text17: '止损触发价',
      text18: '委托价格',
      text19: '量',
      text20: '价格',
      text21: '止盈价需大于标记价格！',
      text22: '止盈价需小于标记价格！',
      text23: '止损价需小于标记价格！',
      text24: '止损价需大于强平价格！',
      text25: '止损价需大于标记价格！',
      text26: '止损价需小于强平价格！',
      text27: '价格偏差太大！',
      text28: '超出可平数量！',
      text29: '有效期',
      text30: '市价',
      columns1: '合约',
      columns2: '仓位/可平',
      columns3: '成本价',
      columns4: '标记价格',
      columns5: '强平价格',
      columns6: '止盈触发价',
      columns7: '委托价格',
      columns8: '委托数量',
      columns9: '止损触发价',
      columns10: '最新价格',
      time1: '24H',
      time2: '7天',
      time3: '14天',
      time4: '30天',
    },
    order: {
      startTime: '开始时间',
      endTime: '结束时间',
      coType: '合约类型',
      coSide: '合约方向',
      contract: '合约',
      orderType: '订单类型',
      cancelAll: '撤销全部订单',
      title1: '当前委托',
      title2: '计划委托',
      title3: '历史委托',
      title4: '历史计划委托',
      title5: '历史成交',
      typeList1: '永续合约',
      typeList2: '模拟合约',
      typeList3: '混合合约',
      sideType1: 'USDT合约',
      sideType2: '币本位合约',
      all: '全部',
      orderType1: '限价单',
      orderType2: '市价单',
      orderType3: '只做maker', // PostOnly
      orderType4: 'IOC',
      orderType5: 'FOK',
      orderType6: '强制平仓',
      orderType7: '仓位合并',
      time: '时间',
      side: '方向',
      intrustPrice: '委托价格',
      intrustVolume: '委托数量(张)',
      dealVolume: '成交数量(张)',
      dealPrice: '成交均价',
      priceDeal: '成交价格',
      onlyCut: '只减仓',
      opera: '操作',
      triggerPrice: '触发价',
      intrustVolumeOrNum: '委托数量/价值',
      overTime: '过期时间',
      status: '状态',
      submitTime: '提交委托时间',
      triggerTime: '触发时间',
      roles: '角色',
      fee: '手续费',
      status1: '新订单',
      status2: '完全成交',
      status3: '部分成交',
      status4: '已撤单',
      status5: '待撤销',
      status6: '异常订单',
      status7: '部分成交已撤销',
      contractType1: '永续',
      contractType2: '当周',
      contractType3: '次周',
      contractType4: '月度',
      contractType5: '季度',
      statusText1: '有效',
      statusText2: '已撤单',
      statusText3: '已完成',
      statusText4: '下单失败',
      open: '开',
      close: '平',
      buy: '多',
      sell: '空',
      currentPrice: '市价',
      yes: '是',
      no: '否',
      per: '张',
      cancel: '取消',
      memoText1: '用户取消',
      memoText2: '超过有效期',
      memoText3: '最新价格达到',
      memoText4: '触发计划委托，因账户保证金余额不足，委托无法提交，执行失败',
      memoText5: '触发计划委托，因仓位可平数量不足，无法提交委托，执行失败',
      memoText6: '触发计划委托，因仓位发生强平，无法提交委托，执行失败',
      memoText7: '触发计划委托，因该合约已被暂停交易，无法提交委托，执行失败',
    },
    coFlowingWater: {
      startTime: '开始时间',
      endTime: '结束时间',
      coin: '币种',
      type: '类型 ',
      all: '全部',
      transferIn: '转入',
      transferOut: '转出',
      fee: '资金费用',
      loss: '分摊',
      time: '时间',
      amount: '金额',
      typeList1: '手续费分成',
      typeList2: '赠金发放',
      typeList3: '赠金回收',
      typeList4: '平仓手续费',
      typeList5: '开仓手续费',
    },
    coAccount: {
      coAccount: '合约账户',
      transfer: '划转',
      coin: '币种',
      canUser: '可用',
      allBalance: '总资产',
      allMargin: '全仓保证金',
      subMargin: '逐仓保证金',
      lockMargin: '冻结保证金',
      opera: '操作',
    },
    transfer: {
      transfer: '资金划转',
      from: '从',
      to: '划转到',
      coin: '币种',
      volume: '划转数量',
      volumeError: '可用数量不足',
      all: '全部',
      canTransfer: '可转',
      confirm: '确定',
      cantIn: '限制转入',
      cantOut: '限制转出',
      exchangeAccount: '现货账户',
      coAccount: '合约账户',
      noBonus: '不包含体验金',
      bonusNote: '体验金本身不能直接提现，盈利部分可提。 体验金可用于开仓、交易手续费、资金费用、平仓盈亏结算。 平仓亏损、手续费等最后扣除体验金。',
    },
    assets: {
      text1: '资产',
      text2: '合约信息',
      text3: '立即划转',
      text4: '更多',
      text5: '账户保证金率',
      text6: '账户保证金率 = 账户总资产 / 总占用保证金。此值用来表示担保资产的大致水平，保证金率越低，仓位被强制平仓的风险越大。',
      text7: '总资产',
      text8: '合约账户总权益。账户总权益=全仓总权益+逐仓总权益+冻结保证金。',
      text9: '全仓保证金',
      text10: '所有用来担保全仓仓位的保证金。当全仓仓位被强制平仓时，会损失这些资产。请注意：转入合约账户的资产会自动作为全仓保证金。',
      text11: '逐仓保证金',
      text12: '所有用来担保逐仓仓位的保证金。逐仓保证金和全仓分开，全仓仓位被强制平仓不会影响到这部分资产。',
      text13: '冻结保证金',
      text14: '提交委托时冻结的委托保证金总和。',
      text15: '合约代号',
      text16: '交割日期',
      text17: '合约标的',
      text18: '指数',
      text19: '保证金币种',
      text20: '合约面值',
      text21: '最小价格变动单位',
      text22: '最低维持保证金率',
      text23: '结算周期',
      text24: [
        '永续',
        '周',
        '次周',
        '月',
        '季度',
      ],
      text25: '合约数据',
    },
    assetsChart: {
      text1: '逐仓',
      text2: '全仓',
      text3: '冻结',
    },
  },
  futuresData: {
    navTitle: '合约数据',
    typeTabList1: 'USDT合约',
    typeTabList2: '币本位合约',
    typeTabList3: '混合合约',
    typeTabList4: '模拟合约',
    promptText1: '保险基金币种',
    promptText2: '合约类型',
    promptText3: '合约',
    tabList1: '永续合约保险基金',
    tabList2: '资金费率',
    tabList3: '指数价格',
    tabList4: '标记价格',
    columns1: '时间',
    columns2: '流水类型',
    columns3: '金额',
    columns4: '合约',
    columns5: '当期资金费率',
    columns6: '交易所',
    columns7: '权重',
    tbaleTitle1: '收支记录',
    tbaleTitle2: '历史数据',
    tbaleTitle3: '指数价格组成',
    moreText1: '了解保险基金',
    moreText2: '了解资金费率',
    moreText3: '了解指数价格',
    moreText4: '了解标记价格',
    text1: '所有以USDT为保证金的永续合约的保险基金余额为',
    text2: '接管盈利注入',
    text3: '风险准备金支出',
  },
  creditCard: {
    title: '信用卡交易',
    amount: '购买数量',
    num: '购买金额(不含手续费)',
    buy: '立即购买',
    mark: 'MoonPay让每个人都可以更轻松，更快速，更安全地购买数字货币。它接受所有主流的借记卡/信用卡，和包括Apple Pay在内的新的移动支付方式。',
    warnTit: '请注意',
    warn1: '1.数字货币价格是根据当前报价并非最终成交价, 如果价格变化超过+/-2.5%你将收到来自MoonPay的重新交易确认。',
    warn2: '2. 完成购买后，您的$<订单状态>$可以在MoonPay查看，您的$<充值记录>$可以在交易所查看。',
    warn3: '3.如果你有任何问题，请联系MoonPay的客服服务(support@moonpay.io)。',
    confirmTit: '即将跳转至MoonPay',
    confirmBtn: '前往 MoonPay 支付',
    confirmText1: 'MoonPay会在您付款成功后的2~10分钟之内，将您购买的数字货币充值到您的现货账户充值地址中。',
    confirmText2: '您已知晓 MoonPay 是由第三方独立运营的法定货币与数字货币交易平台，本交易所不对因使用该服务遭受的任何损失或损害承担任何责任。',
    callBackTit: 'MoonPay支付反馈',
    callBackTrue: '去交易',
    callBackFalse: '查看资产',
    callBackText1: '1.当付款完成，您会收到来自MoonPay的邮件。你可以在MoonPay$<查询付款状态>$。',
    callBackText2: '2. 付款完成后，MoonPay将通过充值的方式充值至您的现货账户。',
    callBackText3: '3. 如果你有任何问题，请联系MoonPay的客服服务(support@moonpay.io)。',
  },
};
